import {
  agentResourceQuery,
  createResourceBody,
  createResourceFileBody,
  createResourceFolderBody,
  hubResourceQuery,
  linkAgentResourceBody,
  listResourceFilesQuery,
  listResourceFoldersQuery,
  listResourcesQuery,
  resourceFileIdParam,
  resourceFolderIdParam,
  resourceIdParam,
  syncSkillsBody,
  unlinkAgentResourceQuery,
  updateAgentResourceBody,
  updateResourceBody,
  updateResourceFileBody,
  updateResourceFolderBody,
  uploadResourceFileBody,
  uploadSkillZipBody
} from "../chunk-TIZ57ZBA.js";
import {
  createStateBody,
  listStatesQuery,
  reorderStatesBody,
  stateIdParam,
  updateStateBody
} from "../chunk-Q7KIQHAZ.js";
import {
  addConnectionBody,
  connectionIdParam,
  connectorIdParam,
  deleteConnectionQuery,
  editConnectionBody,
  listConnectionsQuery,
  registerWhatsappBody,
  registerWhatsappQuery,
  resendDomainStatusQuery,
  retryProvisioningQuery,
  setProductionCredentialBody
} from "../chunk-2U4BTOR7.js";
import {
  createExperimentBody,
  createVariantBody,
  deleteOverrideQuery,
  experimentIdParam,
  listExperimentsQuery,
  listOverridesQuery,
  listVariantsQuery,
  setExperimentStatusBody,
  updateExperimentBody,
  updateVariantBody,
  upsertOverrideBody,
  variantIdParam
} from "../chunk-IPXBFWUU.js";
import {
  BASE_CREDENTIAL_MANAGED_BY,
  BASE_CREDENTIAL_NAME_MAX,
  baseCredentialLinkParams,
  baseCredentialLinkQuery,
  baseCredentialNameSchema,
  createBaseCredentialLinkBody
} from "../chunk-GK27ENTT.js";
import {
  createOrgCredentialBody,
  listOrgCredentialsQuery,
  orgCredentialIdParam,
  updateOrgCredentialBody
} from "../chunk-SXDX4GHS.js";
import {
  createOrgResourceBody,
  createOrgResourceFolderBody,
  hubOrgResourceParam,
  linkOrgResourceBody,
  listOrgResourcesQuery,
  orgIdQuery,
  orgResourceFileIdParam,
  orgResourceFolderIdParam,
  orgResourceIdParam,
  updateOrgResourceBody,
  updateOrgResourceFileBody,
  updateOrgResourceFolderBody,
  uploadOrgResourceFileBody,
  uploadOrgSkillZipBody
} from "../chunk-FK6HBXM7.js";
import {
  ORG_TAG_NAME_MAX_LENGTH,
  ORG_TAG_NAME_REGEX,
  createOrgTagBody,
  listOrgTagsQuery,
  orgTagIdParam,
  updateOrgTagBody
} from "../chunk-VXEAR36B.js";
import {
  bootstrapQuery,
  isPeopleSurfaceOn
} from "../chunk-GPM7PE44.js";
import {
  TOKEN_LIMITS,
  createTokenBody,
  tokenIdParam,
  tokenOrgIdParam
} from "../chunk-DGKMMFIR.js";
import {
  APPEARANCE_MODES,
  DEFAULT_APPEARANCE,
  activityQuery,
  appearanceFromDarkMode,
  darkModeForAppearance,
  deletePushTokenQuery,
  deletionModeSchema,
  deletionRequestBody,
  isAppearanceMode,
  isDarkAppearance,
  recordAiDisclosureAcceptanceBody,
  registerPushTokenBody,
  updatePreferencesBody,
  updateProfileBody,
  updateUserBody
} from "../chunk-ZC6YGHNX.js";
import {
  VAULT_LIMITS,
  vaultCreateBody,
  vaultIdParam,
  vaultSecretScopeSchema,
  vaultUpdateBody
} from "../chunk-ACKF2MVU.js";
import {
  ADMIN_PEOPLE_ACTIONS_MAX,
  ADMIN_PEOPLE_REPORTS_PAGE_DEFAULT,
  ADMIN_PEOPLE_REPORTS_PAGE_MAX,
  PEOPLE_MODERATION_NOTE_MAX_LENGTH,
  PEOPLE_SUSPENDED_REASON,
  adminPeopleMessageRemovalBody,
  adminPeopleNoteBody,
  adminPeopleReportIdParam,
  adminPeopleReportListQuery,
  adminPeopleSuspendBody,
  adminPeopleUserIdParam,
  peopleModerationActionSchema
} from "../chunk-ZXK6N2HN.js";
import {
  PEOPLE_REPORTS_PER_DAY,
  PEOPLE_REPORT_CONTEXT_MESSAGES,
  PEOPLE_REPORT_DETAILS_MAX_LENGTH,
  peopleReportBody,
  peopleReportReasonSchema
} from "../chunk-Y7CFCYX4.js";
import {
  rekorBaseChangeMessageSchema
} from "../chunk-5DGHIY7L.js";
import {
  REKOR_BASE_INCARNATION_MISMATCH,
  REKOR_CUSTOMER_SCOPE_MISMATCH,
  REKOR_CUSTOMER_SCOPE_REQUIRED,
  REKOR_STRUCTURAL_ID_PATTERN,
  REKOR_TOOL_NOT_FOUND,
  SERVER_OWNED_CONNECTION_SETTINGS,
  TOOLSET_BINDING_SETTING,
  TOOLSET_CATALOG_ONLY_REFUSAL,
  TOOLSET_CONNECTION_CHANGED_REFUSAL,
  TOOLSET_CUSTOMER_FACING_REFUSAL,
  TOOLSET_ENVIRONMENT_REFUSAL,
  TOOLSET_FILE_OPERATIONS,
  TOOLSET_SLUG_PATTERN,
  TOOLSET_SLUG_SETTING,
  TOOLSET_UNRESOLVED_CREDENTIAL_REFUSAL,
  bindingRefusedToCustomerFacing,
  customerFacingRefusalText,
  isCustomerFacingAgentRole,
  readToolsetBinding,
  rekorBoundAttestation,
  rekorResolvedToolsetSchema,
  rekorToolsetCallPath,
  rekorToolsetFileGetSchema,
  rekorToolsetFileListSchema,
  rekorToolsetFilePutSchema,
  rekorToolsetFileSchema,
  rekorToolsetResolvePath,
  rekorToolsetToolsPath,
  rekorToolsetToolsSchema,
  resolvedToolsetIsBound,
  summarizeToolsetSurface,
  toolsetBindingAllowsCustomerFacing,
  toolsetConnectionBindingSchema,
  toolsetConnectionRefusalMessage,
  toolsetFileToolName,
  toolsetFileToolSchema,
  toolsetSurfaceSchema,
  withoutServerOwnedSettings
} from "../chunk-BVQE66I2.js";
import {
  DATA_BASE_GENERATION_HEADER,
  DATA_FILE_UPLOAD_HEADERS,
  DATA_PROXY_ORG_QUERY_PARAM,
  MAX_PROVISIONING_BODY_BYTES,
  MAX_REKOR_TOOL_ID_LENGTH,
  REKOR_ACTOR_ADMIN_HEADER,
  REKOR_ACTOR_ID_HEADER,
  REKOR_ACTOR_LABEL_HEADER,
  REKOR_ACTOR_ORG_HEADER,
  REKOR_ACTOR_TYPE_HEADER,
  REKOR_BINDING_ORIGIN,
  REKOR_BOUND_BASE_HEADER,
  REKOR_BOUND_CUSTOMER_HEADER,
  REKOR_BOUND_TOKEN_HEADER,
  REKOR_BOUND_TOOLSET_HEADER,
  REKOR_CLIENTS,
  REKOR_CLIENT_HEADER,
  REKOR_INLINE_PROJECTION_BODY_KEY,
  REKOR_LIFECYCLE_PREFIX,
  REKOR_MAX_ACTOR_ID_LENGTH,
  REKOR_MAX_ACTOR_LABEL_LENGTH,
  REKOR_TOOL_ID_HEADER,
  REKOR_V1_PREFIX,
  REQUIRED_REKOR_ATTESTATION_HEADERS,
  WAYAI_ATTESTED_CLIENT,
  WAYAI_TOOL_ID_HEADER,
  dataProxyQuery,
  rekorAttestation,
  rekorBaseErasurePath,
  rekorClientSchema,
  rekorToolIdSchema
} from "../chunk-BEOHBREG.js";
import {
  GITHUB_ISSUE_URL_REGEX,
  REPORT_CONTEST_CAP,
  REPORT_TERMINAL_STATUSES,
  contestReportBody,
  createReportBody,
  editReportBody,
  getReportEditRejection,
  getReportHoldRejection,
  getReportRecurrenceOutcome,
  getReportResponseSchema,
  getReportTransitionRejection,
  groupReportsBody,
  holdReportBody,
  intakeReportSourceSchema,
  listReportsQuery,
  reportClassificationSchema,
  reportLocaleSchema,
  reportMessageAuthorRoleSchema,
  reportMessageSchema,
  reportSourceSchema,
  reportStatusSchema,
  reporterListQuery,
  reporterListResponseSchema,
  reporterReportSummarySchema,
  reporterTransitionResponseSchema,
  sentryRefStatusSchema,
  transitionReportBody
} from "../chunk-IPDOHAZ5.js";
import {
  getHubUserContextResponse,
  stateResetParams,
  stateResetResponse,
  unlockHubUserNameResponse,
  updateHubUserBody,
  updateHubUserResponse
} from "../chunk-SY6PLCPK.js";
import {
  invitePreviewQuery,
  invitePreviewResponse,
  inviteUnsubscribeBody
} from "../chunk-YUZFHVB2.js";
import {
  createTemplateBody,
  deleteTemplateQuery,
  listTemplatesQuery,
  submitTemplateBody,
  templateIdParam,
  templateStatusQuery,
  testTemplateBody,
  updateTemplateBody
} from "../chunk-34LE6P7E.js";
import {
  NOTICE_SCOPE_REGEX,
  createNoticeBody,
  listNoticesQuery,
  noticeIdParamSchema,
  noticeScopeSchema,
  noticeSeveritySchema,
  noticeStatusSchema,
  updateNoticeBody
} from "../chunk-FPSDNS2E.js";
import {
  DESKTOP_APP_PATH_MAX_LENGTH,
  DESKTOP_BADGE_LABEL_MAX_LENGTH,
  DESKTOP_BADGE_MAX_COUNT,
  DESKTOP_BRIDGE_CHANNELS,
  DESKTOP_BRIDGE_EVENTS,
  DESKTOP_BRIDGE_GLOBAL,
  DESKTOP_BRIDGE_VERSION,
  DESKTOP_FLAVORS,
  DESKTOP_NOTIFICATION_BODY_MAX_LENGTH,
  DESKTOP_NOTIFICATION_KINDS,
  DESKTOP_NOTIFICATION_TITLE_MAX_LENGTH,
  DESKTOP_PLATFORMS,
  DESKTOP_PRESENCE_STATES,
  DESKTOP_SHELL_VERSION_RE,
  DESKTOP_SIGN_IN_MAX_AGE_SECONDS,
  DESKTOP_SIGN_IN_URL_MAX_LENGTH,
  desktopAppPathSchema,
  desktopBadgeSchema,
  desktopBridgeArgsSchemas,
  desktopNavigateSchema,
  desktopNotificationSchema,
  desktopPresenceSchema,
  desktopSettingsChangeSchema,
  desktopSettingsSchema,
  desktopShellInfoSchema,
  desktopShowsCustomerWords,
  desktopUpdateSchema
} from "../chunk-LKBSHANA.js";
import {
  EVAL_CALL_MAX_SECONDS,
  EVAL_CALL_MIN_SECONDS,
  EVAL_CALL_RECORD_MAX_REPLY_CHARS,
  EVAL_CALL_RECORD_MAX_TURNS,
  EVAL_CALL_RECORD_MAX_UTTERANCES,
  EVAL_CALL_SPOKEN_LINE_MAX_CHARS,
  createEvalCallBody,
  createEvalCallResponse,
  evalCallBody,
  evalCallConversationQuery,
  evalCallFinishBody,
  evalCallFinishResponse,
  evalCallRecordQuery,
  evalCallRecordResponse,
  evalCallRecording,
  evalCallSpeaker,
  evalCallTurn,
  evalCallUtterance,
  evalCallWebPath
} from "../chunk-VOC3AGY4.js";
import {
  SIGN_URL_MAX_EXPIRES_IN_SECONDS,
  applyStoredFileHeaders,
  downloadBody,
  inertResponseCsp,
  signUrlBody,
  uploadQuery
} from "../chunk-C4HEZ7ZI.js";
import {
  GUIDE_HUB_INELIGIBLE_REASON,
  adminSetGuideHubBody
} from "../chunk-IR2NOSI3.js";
import {
  hubAlert,
  hubAlertSeverity,
  hubAlertsListResponse,
  hubAlertsParam
} from "../chunk-EA23LSDS.js";
import {
  CONSULT_AWAIT_TIMEOUT_MS,
  CONSULT_MAX_DEPTH,
  CONSULT_MAX_PER_COMPLETION,
  CONSULT_MAX_PER_CONVERSATION,
  CONSULT_SYNC_TURN_BUDGET_MS,
  CONSULT_SYSTEM_EVENTS,
  CONSULT_TEAM_TAKEOVER_NOTICE,
  CONSULT_THREAD_STATUSES,
  consultThreadIdParam,
  consultThreadStatus,
  consultThreadSummary,
  consultThreadTitle,
  createConsultThreadBody,
  createConsultThreadResponse,
  isConsultSystemEvent,
  listConsultThreadsQuery,
  listConsultThreadsResponse,
  updateConsultThreadBody,
  updateConsultThreadResponse
} from "../chunk-3O5XTDI2.js";
import {
  conversationListResourcesQuery,
  conversationReadResourceQuery
} from "../chunk-LWMLR2WI.js";
import {
  listHubAggregateSchedulesQuery,
  listPendingSchedulesQuery
} from "../chunk-ACGAI25T.js";
import {
  stateOperationBody
} from "../chunk-MH4O3YEX.js";
import {
  additionalContextPayloadSchema,
  annotateConversationBody,
  claimBody,
  closeBody,
  conversationHubQuery,
  conversationIdParam,
  deleteUserConversationsBody,
  deleteUserConversationsResponse,
  getConversationDetailParams,
  getConversationDetailQuery,
  getConversationDetailResponse,
  getConversationsResponse,
  kanbanUpdateBody,
  listConversationsQuery,
  listWhatsAppTemplatesQuery,
  observabilityListParams,
  observabilityParams,
  releaseBody,
  sendMessageBody,
  sendWhatsAppTemplateBody,
  transferBody
} from "../chunk-YVHDDEQV.js";
import {
  copilotSuggestBody,
  copilotSuggestResponse
} from "../chunk-KSTYTQ7I.js";
import {
  APP_MESSAGE_CONVERSATION_ID_HEADER,
  apiChannelMessage,
  apiChannelMessageBody,
  appMessageBody,
  appMessageReceiverType,
  appMessageResponse,
  appMessageSenderType
} from "../chunk-7CYHPF35.js";
import {
  ACTIVE_LIST_DEFAULT_LIMIT,
  ACTIVE_LIST_MAX_LIMIT,
  DIAGNOSTIC_CODES,
  getConversationsQuery,
  getMessagesQuery,
  mergeFlagSource
} from "../chunk-BPCNB5RT.js";
import {
  CI_APPLY_ENTITY_KINDS,
  CI_APPLY_ERROR_CLASSIFICATIONS,
  CI_APPLY_OPERATIONS,
  HUB_AS_CODE_AGENT_KEYS,
  HUB_AS_CODE_AGENT_TOOL_KEYS,
  HUB_AS_CODE_AUTOMATION_ACTION_KEYS,
  HUB_AS_CODE_AUTOMATION_GATE_KEYS,
  HUB_AS_CODE_AUTOMATION_KEYS,
  HUB_AS_CODE_AUTOMATION_TARGET_KEYS,
  HUB_AS_CODE_AUTOMATION_TRIGGER_KEYS,
  HUB_AS_CODE_CONTACT_LIST_FILTER_KEYS,
  HUB_AS_CODE_CONTACT_LIST_KEYS,
  MAX_10MB_BASE64_ENCODED_BYTES,
  MAX_CALL_OPENING_AGGREGATE_ENCODED_BYTES,
  MAX_CALL_OPENING_CARRIERS,
  MAX_CI_CONFIG_BODY_BYTES,
  MAX_EVAL_ATTACHMENT_AGGREGATE_ENCODED_BYTES,
  MAX_EVAL_ATTACHMENT_CARRIERS,
  MAX_EVAL_ATTACHMENT_ENCODED_BYTES,
  MAX_HUB_AS_CODE_RESOURCES,
  MAX_HUB_AS_CODE_RESOURCE_FILES,
  MAX_RESOURCE_AGGREGATE_ENCODED_BYTES,
  MAX_RESOURCE_ENCODED_BYTES,
  ciApplyErrorSchema,
  ciBranchParam,
  ciBranchesQuery,
  ciDiffBody,
  ciHubsQuery,
  ciLookupQuery,
  ciOrgResourcesDiffBody,
  ciOrgResourcesParam,
  ciOrgResourcesPushBody,
  ciPublishBody,
  ciPublishPreviewBody,
  ciPullHubIdParam,
  ciPullQuery,
  ciPushBody,
  ciSyncBody,
  ciSyncChangesSchema,
  ciSyncMcpBody,
  ciSyncResponseSchema,
  ciSyncWarningSchema,
  hubAsCodeResourceFileSchema,
  hubAsCodeResourceSchema,
  hubAsCodeStateSchema
} from "../chunk-DBQLPVOO.js";
import {
  CONTEXT_BOUNDARIES,
  DEFAULT_CONTEXT_BOUNDARY,
  addMcpToolBody,
  addNativeToolBody,
  createCustomToolBody,
  deleteToolQuery,
  isMessageKept,
  keepInHistoryToInt,
  listToolsQuery,
  resolveContextBoundary,
  resolveKeepInHistory,
  toolAgentQuery,
  toolConnectionsQuery,
  toolIdParam,
  updateCustomToolBody,
  updateToolExecutionConfigBody
} from "../chunk-D26NGKIY.js";
import {
  ATTACHMENTS_USER_ONLY_MESSAGE,
  EVAL_FIXTURE_NAME_MAX_LENGTH,
  EVAL_INITIAL_STATE_SCOPES,
  EVAL_INPUT_ROLES,
  EVAL_LIST_MAX_LIMIT,
  EVAL_MAX_SELECTED_SCENARIOS,
  EVAL_RUN_ERROR_KINDS,
  EVAL_RUN_OUTCOME_KINDS,
  EVAL_SESSION_NOT_QUIESCENT,
  MAX_INITIAL_STATE_ENTRIES,
  RUN_SESSION_ERRORS,
  SEED_LEASE_WARNINGS,
  asEvalInputRecord,
  bulkToggleEvalsBody,
  collectTurnAttachmentHashes,
  compareSessionsQuery,
  createEvalBody,
  createJourneyBody,
  createJourneyFromConversationBody,
  createScenarioFromConversationBody,
  createScenarioSetBody,
  createSessionBody,
  deriveEvalRunOutcomeKind,
  evalAnalyticsQuery,
  evalAttachmentRef,
  evalCustomerContactIdError,
  evalCustomerContactIdSchema,
  evalFixtureOverrideSchema,
  evalIdParam,
  evalInitialStateEntry,
  evalInitialStateError,
  evalInputRoleError,
  evalNameError,
  evalScenarioSelectionEntrySchema,
  evalScenarioSelectionSchema,
  evalSeedStateUserId,
  evalSessionConfigResponseSchema,
  evalSessionListConfigSchema,
  evalSessionListItemSchema,
  evalSessionResponseSchema,
  evalTurnAttachmentsError,
  evalsSqlBody,
  evalsSqlSchemaQuery,
  evaluatedRunCount,
  exportResultsQuery,
  getEvalsQuery,
  getSessionCostQuery,
  getSessionResultsQuery,
  getSessionRunsQuery,
  getSessionsQuery,
  hubAgentsQuery,
  hubIdQuery,
  journeyIdParam,
  pacingConfigSchema,
  runJourneyQuery,
  runSessionQuery,
  scenarioSetIdParam,
  scenarioSetsHubQuery,
  seedReleaseStatusSchema,
  sessionConfigSchema,
  sessionIdParam,
  terminalRunCount,
  toggleEvalBody,
  turnMayCarryAttachments,
  unprovenRunCount,
  updateEvalBody,
  updateJourneyBody,
  updateScenarioSetBody,
  validateEvalBody
} from "../chunk-7MRZJN4O.js";
import {
  clickhouseReadyResponse
} from "../chunk-JDJ4EUOL.js";
import {
  COMMUNITY_COURSES_MAX,
  COMMUNITY_COURSES_REASON,
  COMMUNITY_COURSE_DESCRIPTION_MAX_LENGTH,
  COMMUNITY_COURSE_LESSONS_MAX,
  COMMUNITY_COURSE_LESSONS_REASON,
  COMMUNITY_COURSE_MODULES_MAX,
  COMMUNITY_COURSE_MODULES_REASON,
  COMMUNITY_COURSE_TITLE_MAX_LENGTH,
  COMMUNITY_LESSONS_MAX,
  COMMUNITY_LESSONS_REASON,
  COMMUNITY_LESSON_BODY_MAX_LENGTH,
  COMMUNITY_LESSON_LINKS_MAX,
  COMMUNITY_LESSON_PROGRESS_REASON,
  COMMUNITY_LESSON_URL_MAX_LENGTH,
  COMMUNITY_LESSON_VIDEO_PROVIDERS,
  COMMUNITY_PROGRESS_COMMUNITIES_MAX,
  communityCourseCreateBody,
  communityCourseDescriptionSchema,
  communityCourseIdParam,
  communityCourseModuleIdParam,
  communityCoursePositionSchema,
  communityCourseTitleSchema,
  communityCourseUpdateBody,
  communityLessonBodySchema,
  communityLessonCreateBody,
  communityLessonIdParam,
  communityLessonLinkSchema,
  communityLessonLinksSchema,
  communityLessonUpdateBody,
  communityLessonVideoEmbedUrl,
  communityLessonVideoUrlSchema,
  communityLessonVideoWatchUrl,
  communityModuleCreateBody,
  communityModuleUpdateBody,
  communityNextLessonId,
  communityOutlineLessonIds,
  parseCommunityLessonVideoUrl
} from "../chunk-QAWIPRNA.js";
import {
  COMMUNITIES_PER_ORG_MAX,
  COMMUNITIES_PER_ORG_REASON,
  COMMUNITIES_PER_PERSON_MAX,
  COMMUNITIES_PER_PERSON_REASON,
  COMMUNITY_ACCESS_ADD_MAX,
  COMMUNITY_ACCESS_FULL_REASON,
  COMMUNITY_ACCESS_MAX,
  COMMUNITY_ACCESS_PAGE_SIZE,
  COMMUNITY_ADMISSIONS,
  COMMUNITY_ANNOUNCEMENTS_LIMIT,
  COMMUNITY_ANNOUNCEMENTS_PER_DAY,
  COMMUNITY_ANNOUNCEMENT_PUSH_KIND,
  COMMUNITY_ATTACHMENT_MAX_BYTES,
  COMMUNITY_ATTACHMENT_TYPES,
  COMMUNITY_ATTACHMENT_TYPE_REASON,
  COMMUNITY_ATTACHMENT_URLS_MAX,
  COMMUNITY_ATTACHMENT_URL_TTL_SECONDS,
  COMMUNITY_COURSES_LABEL_MAX_LENGTH,
  COMMUNITY_DAILY_LIMIT,
  COMMUNITY_EMAIL_UNSUBSCRIBE_PAGE_PATH,
  COMMUNITY_FULL_REASON,
  COMMUNITY_JOIN_FLOW_TOKEN_MAX_LENGTH,
  COMMUNITY_JOIN_SOURCE_MAX_LENGTH,
  COMMUNITY_LIVE_CLOSE_ENDED,
  COMMUNITY_LIVE_CLOSE_EXPIRED,
  COMMUNITY_LIVE_CLOSE_OFF,
  COMMUNITY_LIVE_MESSAGES_LIMIT,
  COMMUNITY_LIVE_MESSAGES_MAX,
  COMMUNITY_LIVE_SOCKETS_MAX,
  COMMUNITY_LIVE_SOCKETS_PER_PERSON_MAX,
  COMMUNITY_LIVE_SOCKET_MAX_AGE_SECONDS,
  COMMUNITY_LIVE_TICKET_PREFIX,
  COMMUNITY_LIVE_TICKET_TTL_SECONDS,
  COMMUNITY_MEMBERS_MAX,
  COMMUNITY_MEMBER_MESSAGES_PER_DAY,
  COMMUNITY_MEMBER_ROLES,
  COMMUNITY_MEMBER_STATUSES,
  COMMUNITY_MESSAGES_PAGE_SIZE,
  COMMUNITY_MESSAGES_PER_SECOND,
  COMMUNITY_MESSAGE_MAX_LENGTH,
  COMMUNITY_MOD_ACTIONS_MAX,
  COMMUNITY_MOD_ACTIONS_PAGE_SIZE,
  COMMUNITY_MOD_ACTION_KINDS,
  COMMUNITY_NAME_MAX_LENGTH,
  COMMUNITY_NEW_MEMBER_MESSAGES_PER_DAY,
  COMMUNITY_NOT_A_POST_REASON,
  COMMUNITY_NOT_INVITED_REASON,
  COMMUNITY_NOT_JOINED_REASON,
  COMMUNITY_PEOPLE_PAGE_SIZE,
  COMMUNITY_PINS_PER_ROOM_MAX,
  COMMUNITY_PINS_REASON,
  COMMUNITY_POSTS_PAGE_SIZE,
  COMMUNITY_POST_LOCKED_REASON,
  COMMUNITY_POST_PREVIEW_LENGTH,
  COMMUNITY_POST_SEARCH_MAX_LENGTH,
  COMMUNITY_POST_TITLE_MAX_LENGTH,
  COMMUNITY_RANK_REASON,
  COMMUNITY_RATE_LIMIT,
  COMMUNITY_REGISTRY_CLOSED_REASON,
  COMMUNITY_REPLY_PUSH_KIND,
  COMMUNITY_REPORTS_MAX,
  COMMUNITY_REPORTS_PAGE_SIZE,
  COMMUNITY_ROOMS_MAX,
  COMMUNITY_ROOMS_REASON,
  COMMUNITY_ROOM_ARCHIVED_REASON,
  COMMUNITY_ROOM_KIND_REASON,
  COMMUNITY_ROOM_NAME_MAX_LENGTH,
  COMMUNITY_RULES_MAX_LENGTH,
  COMMUNITY_SLOW_MODE_LIMIT,
  COMMUNITY_SLOW_MODE_MAX_SECONDS,
  COMMUNITY_STATS_DAYS,
  COMMUNITY_STATS_SOURCES_MAX,
  COMMUNITY_VIEWER_ROLES,
  adminCreateCommunityBody,
  communityAccessAddBody,
  communityAccessEmailSchema,
  communityAccessIdParam,
  communityAccessQuery,
  communityAdmissionSchema,
  communityAnswerBody,
  communityAttachmentUploadSchema,
  communityAttachmentUrlsBody,
  communityBanBody,
  communityCoursesLabelSchema,
  communityEditBody,
  communityEmailUnsubscribeQuery,
  communityEmailUnsubscribeTokenSchema,
  communityIdParam,
  communityJoinBody,
  communityJoinPreviewQuery,
  communityJoinSourceSchema,
  communityJoinTokenSchema,
  communityLiveQuery,
  communityLiveTicketSchema,
  communityLockBody,
  communityMessageBodySchema,
  communityMessageIdParam,
  communityMessagesQuery,
  communityModLogQuery,
  communityMuteBody,
  communityNameSchema,
  communityOrgParam,
  communityPeopleQuery,
  communityPersonParam,
  communityPinBody,
  communityPostIdParam,
  communityPostTitleSchema,
  communityPostsQuery,
  communityReadBody,
  communityReportIdParam,
  communityReportsQuery,
  communityRoomCreateBody,
  communityRoomIdParam,
  communityRoomKindSchema,
  communityRoomNameSchema,
  communityRoomUnreadCount,
  communityRoomUpdateBody,
  communitySendBody,
  communitySettingsBody,
  communityUnreadCount
} from "../chunk-EA2IJGKN.js";
import {
  PEOPLE_ATTACHMENT_STORAGE_LIMIT,
  PEOPLE_ATTACHMENT_STORAGE_PER_USER_BYTES,
  PEOPLE_GROUP_AVATAR_URL_MAX_LENGTH,
  PEOPLE_GROUP_INCOMING_INVITES_MAX,
  PEOPLE_GROUP_INVITES_PER_ADMIN_MAX,
  PEOPLE_GROUP_MEMBERS_MAX,
  PEOPLE_GROUP_NAME_MAX_LENGTH,
  PEOPLE_LIVE_FRAME_TYPES,
  PEOPLE_ORG_ERASURES_PER_DAY,
  PEOPLE_ORG_ERASURE_PAGE,
  PEOPLE_ORG_ROLE_CHECK_MAX,
  PEOPLE_THREAD_ATTACHMENT_MAX_BYTES,
  PEOPLE_THREAD_ATTACHMENT_MAX_MB,
  PEOPLE_THREAD_ATTACHMENT_NAME_MAX_LENGTH,
  PEOPLE_THREAD_ATTACHMENT_URLS_MAX,
  PEOPLE_THREAD_ATTACHMENT_URL_TTL_SECONDS,
  PEOPLE_THREAD_DELIVERIES_PER_DAY,
  PEOPLE_THREAD_HEAD_MAX,
  PEOPLE_THREAD_INLINE_IMAGE_TYPES,
  PEOPLE_THREAD_MESSAGES_PAGE_MAX,
  PEOPLE_THREAD_MESSAGE_MAX_LENGTH,
  PEOPLE_THREAD_PAGE_DEFAULT,
  PEOPLE_THREAD_PAGE_MAX,
  PEOPLE_THREAD_PREVIEW_MAX_LENGTH,
  PEOPLE_THREAD_PUSH_KIND,
  isPeopleInlineImage,
  isPeopleLiveFrameType,
  ownPeopleName,
  peopleGroupAvatarUrlSchema,
  peopleGroupCreateBody,
  peopleGroupIncomingInviteIdParam,
  peopleGroupIncomingInviteSchema,
  peopleGroupInviteBody,
  peopleGroupInviteIdParam,
  peopleGroupLeaveBody,
  peopleGroupMemberParam,
  peopleGroupMemberSchema,
  peopleGroupNameSchema,
  peopleGroupRoleSchema,
  peopleGroupSentInviteSchema,
  peopleGroupSummarySchema,
  peopleGroupUpdateBody,
  peopleMessagePreview,
  peopleOrgDirectBody,
  peopleOrgErasureBody,
  peopleThreadAttachmentSchema,
  peopleThreadAttachmentUploadSchema,
  peopleThreadAttachmentUrlsBody,
  peopleThreadIdParam,
  peopleThreadKindSchema,
  peopleThreadLastMessageSchema,
  peopleThreadListQuery,
  peopleThreadMemberSchema,
  peopleThreadMessageIdParam,
  peopleThreadMessageSchema,
  peopleThreadMessagesQuery,
  peopleThreadReadBody,
  peopleThreadSendBody,
  peopleThreadSettingsBody,
  peopleThreadSummarySchema,
  personName,
  threadLabel,
  threadTitle
} from "../chunk-6J742GLA.js";
import {
  PEOPLE_CONTACTS_MAX,
  PEOPLE_CONTACT_BLOCKS_MAX,
  PEOPLE_CONTACT_DECLINE_SUPPRESSION_DAYS,
  PEOPLE_CONTACT_EMAIL_MAX_LENGTH,
  PEOPLE_CONTACT_INCOMING_INVITES_MAX,
  PEOPLE_CONTACT_INVITES_PER_DAY,
  PEOPLE_CONTACT_INVITE_TTL_DAYS,
  PEOPLE_CONTACT_OUTGOING_INVITES_MAX,
  PEOPLE_CONTACT_PAGE_DEFAULT,
  PEOPLE_CONTACT_PAGE_MAX,
  peopleBlockedUserSchema,
  peopleContactBlockBody,
  peopleContactInviteBody,
  peopleContactInviteIdParam,
  peopleContactPageQuery,
  peopleContactPersonSchema,
  peopleContactSchema,
  peopleContactUserIdParam,
  peopleIncomingInviteSchema,
  peopleInviteEmailSchema,
  peopleOutgoingInviteSchema,
  peopleUserIdSchema
} from "../chunk-ZVXO3XL6.js";
import {
  COMMUNITY_LESSON_CONTAINER_PREFIX_MAX_COLUMNS,
  COMMUNITY_LESSON_LINE_PREFIX_TOO_WIDE_REASON,
  COMMUNITY_LESSON_LINK_PROTOCOLS,
  COMMUNITY_LESSON_TREE_MAX_BYTES,
  COMMUNITY_LESSON_TREE_MAX_DEPTH,
  COMMUNITY_LESSON_TREE_TOO_DEEP_REASON,
  COMMUNITY_LESSON_TREE_TOO_LARGE_REASON,
  COMMUNITY_LESSON_TREE_VERSION,
  communityLessonLinkUrl
} from "../chunk-YULHXJ5M.js";
import {
  archiveConversationParams,
  archiveHubIdParam,
  archiveListQuery,
  archiveMessageObservabilityParams
} from "../chunk-UEJOG2Q7.js";
import {
  META_ENTITY_ID_PATTERN,
  authMeResponse,
  isReviewAccountEmail,
  logoutResponse,
  magicCodeSendBody,
  magicCodeSendResponse,
  magicCodeVerifyBody,
  magicCodeVerifyResponse,
  metaEntityId,
  passwordLoginBody,
  passwordLoginResponse,
  sessionCheckResponse,
  whatsappCallbackBody,
  wsTicketResponse
} from "../chunk-ZHJEQBXJ.js";
import {
  AUTOMATIONS_PER_HUB_MAX,
  AUTOMATION_ACTION_CHANNELS,
  AUTOMATION_ACTION_FIELDS,
  AUTOMATION_ACTION_TYPES,
  AUTOMATION_ALERT_CATEGORIES,
  AUTOMATION_BLOCKED_ALERT_CATEGORY,
  AUTOMATION_CHAIN_MAX_DEPTH,
  AUTOMATION_CHANNEL_TYPES,
  AUTOMATION_CRON_MAX,
  AUTOMATION_DESCRIPTION_MAX,
  AUTOMATION_EVENT_SUBSCRIPTIONS_PER_HUB_MAX,
  AUTOMATION_EVENT_TYPES,
  AUTOMATION_GATE_DECISIONS,
  AUTOMATION_INSTRUCTIONS_MAX,
  AUTOMATION_ITEM_GATE_DECISIONS,
  AUTOMATION_NAME_MAX,
  AUTOMATION_PURPOSES,
  AUTOMATION_RUNS_PAGE_MAX,
  AUTOMATION_RUN_ERROR_CODES,
  AUTOMATION_RUN_STATUSES,
  AUTOMATION_TARGET_TYPES,
  AUTOMATION_TEXT_MAX,
  AUTOMATION_TRIGGER_TYPES,
  AUTOMATION_WEBHOOK_AUTHS,
  AUTOMATION_WEBHOOK_BODY_MAX_BYTES,
  AUTOMATION_WEBHOOK_DEDUPE_KEY_MAX,
  AUTOMATION_WEBHOOK_HEADERS,
  AUTOMATION_WEBHOOK_HEADER_NAME_MAX,
  AUTOMATION_WEBHOOK_MAX_SKEW_SECONDS,
  DEFAULT_AUTOMATION_PURPOSE,
  agentTakesTaskTurn,
  automationActionFields,
  automationActionSchema,
  automationActionTypesFor,
  automationEventSubscriberParam,
  automationGateMonitorFactsOf,
  automationGateMonitorIssue,
  automationGateSchema,
  automationGateTriggerOf,
  automationHubQuery,
  automationIdParam,
  automationOpensTasks,
  automationTakesChannel,
  automationTargetSchema,
  automationTargetTypesFor,
  automationTriggerSchema,
  automationTriggerTypesFor,
  automationWebhookHeaderIssue,
  automationWebhookParams,
  automationWebhookPath,
  createAutomationBody,
  isAutomationEventType,
  isAutomationWebhookAuth,
  listAutomationRunsQuery,
  updateAutomationBody
} from "../chunk-ALUW3KZS.js";
import {
  HUB_CONTACT_LISTS_MAX,
  HUB_CONTACT_LIST_REFUSALS,
  HUB_LIST_FILTER_REQUIRED,
  createHubContactListBody,
  filterNamesAnything,
  hubContactListFilterSchema,
  hubContactListHubQuery,
  hubContactListIdParam,
  hubListNameSchema,
  updateHubContactListBody
} from "../chunk-WNWIYFR3.js";
import {
  AGENT_PARAMETER_NAME_REGEX,
  AUTOMATION_GATE_TRIGGERS,
  CALL_MAX_STEERS_PER_CALL,
  CALL_STEERING_MIN_CONFIDENCE,
  CALL_UTTERANCE_CHECK_CHARS,
  CALL_UTTERANCE_MAX_RUNS_PER_CALL,
  CALL_UTTERANCE_SPEAKERS,
  CALL_UTTERANCE_SPEAKER_DEFAULT,
  INSERT_NOTE_TOOL_NAME,
  MONITOR_AUTOMATION_FIRE_ACTION_KINDS,
  MONITOR_AUTOMATION_ITEM_ACTION_KINDS,
  MONITOR_CASCADE_MAX_DEPTH,
  MONITOR_DELAY_SECONDS_MIN,
  MONITOR_FIRING_TRIGGERS,
  MONITOR_GATE_AGENT_NAME_MAX,
  MONITOR_HISTORY_MESSAGES_DEFAULT,
  MONITOR_HISTORY_MESSAGES_MAX,
  MONITOR_NOTE_RENDERED_MAX,
  MONITOR_RULE_ALLOWED_NATIVE_TOOLS,
  MONITOR_RULE_TRIGGERS,
  MONITOR_RULE_TRIGGER_MESSAGE,
  MONITOR_STEER_NOTE_MAX,
  MONITOR_TRIGGERS,
  RUN_MONITOR_TOOL_NAME,
  agentAssignedToolNames,
  agentConnectionsQuery,
  agentIdParam,
  callSteeringWriteNeedsGate,
  callUtteranceConfidenceNotDeclaredMessage,
  callUtteranceRuleConfident,
  checkCallUtteranceConfidenceDeclared,
  checkMonitorCalleesRunnable,
  checkMonitorRuleToolsAssigned,
  clampMonitorConfigDelay,
  collectMonitorRuleIssues,
  createAgentBody,
  createAgentParametersBody,
  decodedMonitorConfig,
  isAutomationGateTrigger,
  isCallUtteranceSpeaker,
  isEnabledAgentValue,
  isGateActionKind,
  isMonitorRuleCallableTool,
  isNumericEvaluationVariableType,
  isRefusedNativeToolName,
  listAgentsQuery,
  monitorActionSchema,
  monitorCallKeysOffTrigger,
  monitorCalleeRefusal,
  monitorCalleeSelections,
  monitorConfigNeedsDelay,
  monitorFiringTriggerClaim,
  monitorInputShapingKeysOnIdle,
  monitorRuleActionKinds,
  monitorRuleKeysOffTrigger,
  monitorRuleReentryTrack,
  monitorRuleToolNotAllowedMessage,
  monitorRuleToolSelections,
  monitorRulesStructuredOutputMessage,
  monitorRulesStructuredOutputRefusal,
  monitorRulesStructuredOutputWriteRefusal,
  monitorSelectedAction,
  monitorTriggerClashMessage,
  monitorUnassignedToolMessage,
  readInsertNoteKeepInHistory,
  readInsertNoteTemplate,
  readRunMonitorCallee,
  resolveCallUtteranceSpeaker,
  resolveMonitorHistoryMessages,
  resolveMonitorIncludeToolResults,
  resolveMonitorTrigger,
  updateAgentBody
} from "../chunk-6WCPZ26B.js";
import {
  CONTACT_BOOK_CONTACTS_MAX,
  CONTACT_BOOK_EMAIL_UNSUBSCRIBE_PAGE_PATH,
  CONTACT_BOOK_REFUSALS,
  CONTACT_EMAIL_MAX,
  CONTACT_ENVIRONMENTS,
  CONTACT_IMPORT_BATCH_MAX,
  CONTACT_INSTAGRAM_SID_MAX,
  CONTACT_LABELS_MAX,
  CONTACT_LABEL_MAX,
  CONTACT_LINK_CANDIDATES_MAX,
  CONTACT_LISTS_MAX,
  CONTACT_LIST_DESCRIPTION_MAX,
  CONTACT_LIST_FILTER_MAX,
  CONTACT_LIST_NAME_MAX,
  CONTACT_LIST_NAME_REGEX,
  CONTACT_LIST_PINS_MAX,
  CONTACT_LIST_PINS_PER_REQUEST_MAX,
  CONTACT_METADATA_MAX_BYTES,
  CONTACT_NAME_MAX,
  CONTACT_PAGE_MAX,
  CONTACT_PHONE_INPUT_MAX,
  CONTACT_SCOPE_TAGS_MAX,
  CONTACT_SEARCH_MAX,
  SUPPRESSION_IDENTITY_KINDS,
  SUPPRESSION_ID_REGEX,
  SUPPRESSION_SCOPES,
  SUPPRESSION_SOURCES,
  contactBookContactParam,
  contactBookEmailUnsubscribeQuery,
  contactBookEmailUnsubscribeTokenSchema,
  contactBookHubParam,
  contactBookLinkCandidatesQuery,
  contactBookListParam,
  contactBookOrgQuery,
  contactBookPageQuery,
  contactBookSuppressionParam,
  contactImportRowSchema,
  contactListFilterSchema,
  contactVisibilitySchema,
  createContactBookContactBody,
  createContactBookListBody,
  createContactBookSuppressionBody,
  importContactBookContactsBody,
  importRowLabels,
  linkContactBookContactBody,
  listContactBookContactsQuery,
  listContactBookListMembersQuery,
  listContactBookSuppressionsQuery,
  listHubContactBookContactsQuery,
  normalizeContactLabel,
  normalizeContactPhone,
  orgListReferenceSchema,
  scopeTagIdsOf,
  suppressionIdentitySchema,
  updateContactBookContactBody,
  updateContactBookListBody,
  updateContactBookListPinsBody
} from "../chunk-JR2ITK6N.js";
import {
  BASE_DESTRUCTION_CONFIRM_MESSAGES,
  BASE_DESTRUCTION_CONFIRM_TTL_MS,
  BASE_DESTRUCTION_GRACE_MS,
  BASE_DESTRUCTION_ORG_QUERY_PARAM,
  BASE_DESTRUCTION_TOKEN_QUERY_PARAM,
  baseDestructionCancelResponse,
  baseDestructionConfirmBody,
  baseDestructionConfirmPath,
  baseDestructionConfirmResponse,
  baseDestructionConsolePath,
  baseDestructionInitiateBody,
  baseDestructionInitiateResponse,
  baseDestructionListResponse,
  baseDestructionParam,
  baseDestructionQuery,
  baseDestructionRequest,
  baseDestructionStatus
} from "../chunk-IG6QBZMA.js";
import {
  CACHE_RECONCILE_MAX_HUBS,
  CACHE_RECONCILE_MAX_IDS,
  cacheReconcileBody,
  cacheReconcileIdCount,
  cacheReconcileScopeSchema,
  cachedConversationPageSchema,
  cachedHistoryThreadSchema,
  cachedPeopleThreadSchema,
  isPersistablePeopleThread
} from "../chunk-ZJJ5ODOD.js";
import {
  WS_CLIENT_PING_FRAME,
  WS_CLOSE_HIDDEN_IDLE,
  WS_CLOSE_NETWORK_OFFLINE,
  WS_CLOSE_PROBE_TIMEOUT,
  WS_CLOSE_RX_TIMEOUT,
  WS_CLOSE_SERVER_IDLE_PARK,
  WS_CLOSE_SWEEP_TIMEOUT,
  WS_CLOSE_VISIBLE_IDLE,
  WS_SERVER_PONG_FRAME,
  hubCountResetBody,
  navItemCountResetBody,
  navItemSchema,
  typingBody
} from "../chunk-PZPOUXJR.js";
import {
  CALL_OPENING_CAPTION_MAX_CHARS,
  CALL_OPENING_CONTENT_TYPES,
  CALL_OPENING_LANGUAGES,
  CALL_OPENING_MAX_BYTES,
  CALL_OPENING_MAX_DURATION_MS,
  MAX_CALL_OPENING_BODY_BYTES,
  MAX_CALL_OPENING_ENCODED_BYTES,
  agentCallOpeningParams,
  callOpeningCaption,
  callOpeningContentType,
  callOpeningHash,
  callOpeningLanguage,
  callOpeningParam,
  callOpeningQuery,
  callOpeningVersion,
  deleteAgentCallOpeningQuery,
  putAgentCallOpeningBody,
  readStoredCallOpenings,
  storedCallOpening
} from "../chunk-LBDH7LCG.js";
import {
  CALL_OPENINGS_SEGMENT,
  CALL_OPENING_HASH_REGEX,
  EVAL_ATTACHMENT_HASH_REGEX
} from "../chunk-4LXDRTO4.js";
import {
  CALL_END_REASONS,
  CALL_PARTICIPANT_TYPES,
  CALL_REFUSAL_REASONS,
  CALL_STATUSES,
  CALL_TRANSPORTS,
  MAX_CALL_RECORDING_GAPS,
  MAX_CALL_REQUEST_BODY_BYTES,
  MAX_REPORTED_DELEGATION_IDS,
  MAX_SDP_OFFER_LENGTH,
  callDelegationId,
  callDelegationsBody,
  callEndReason,
  callHangupBody,
  callIdParam,
  callParticipantType,
  callReadyBody,
  callRecordingGap,
  callRecordingNoteMetadata,
  callResponse,
  callStatus,
  callStatusQuery,
  callSummary,
  callTransport,
  createCallBody,
  createCallResponse
} from "../chunk-E4DIIOOE.js";
import "../chunk-FMXFEZN4.js";
import "../chunk-5KFFZX2J.js";
import "../chunk-VBUWGVFY.js";
import {
  ADMIN_SKILL_NAME_REGEX,
  adminSkillNameParam
} from "../chunk-NVKU5PPQ.js";
import {
  AUTOMATION_GATE_EVALUATIONS_PER_OPERATION_BOUND,
  AUTOMATION_RUN_RETENTION_DAYS_MAX,
  BRANCHING_ORPHAN_ENTITY_TYPES,
  BRANCHING_ORPHAN_MAX_REFERENCES_SHOWN,
  BRANCHING_ORPHAN_MAX_TARGETS,
  DEBUG_DO_HEX_PREFIX,
  MAX_VOICE_CALL_MINUTE_OPS,
  addAdminUserBody,
  adjustQuotaBody,
  adminHarnessMassDestroyBody,
  adminOrgAdminIdParam,
  adminOrgIdParam,
  adminOrganizationsQuery,
  adminPlanIdParam,
  adminRepairBranchingOrphansBody,
  adminRepairCompedPlansBody,
  adminRepairLegacyOrgGrantsBody,
  adminRepairTeamOrphansBody,
  adminScopedTargetBody,
  adminUserIdParam,
  adminUserSearchQuery,
  automationGateEvaluationsPerOperation,
  automationRunRetentionDays,
  dataExplorerConvIdParam,
  dataExplorerDebugAnalyticsRowsParam,
  dataExplorerDebugAnalyticsRowsQuery,
  dataExplorerDebugAnalyticsTable,
  dataExplorerDebugArchiveParam,
  dataExplorerDebugArchiveQuery,
  dataExplorerDebugObservabilityParam,
  dataExplorerDebugObservabilityQuery,
  dataExplorerDebugRowsParam,
  dataExplorerDebugRowsQuery,
  dataExplorerDebugTablesParam,
  dataExplorerDeleteConvParam,
  dataExplorerDeleteHubParam,
  dataExplorerDeleteOrgParam,
  dataExplorerDeleteQuery,
  dataExplorerDeleteUserParam,
  dataExplorerDoInstancesQuery,
  dataExplorerHubIdParam,
  dataExplorerKvDeleteBody,
  dataExplorerKvKeyBody,
  dataExplorerKvKeysBody,
  dataExplorerNsIdParam,
  dataExplorerOrgIdParam,
  dataExplorerSearchQuery,
  healthSamplingTriggerBody,
  kanbanSlugMigrationQuery,
  pitrBookmarkParam,
  pitrDoNamespace,
  pitrRestoreBody,
  pitrRestoreParam,
  turnDeadlineSeconds,
  updateFreeOrgLimitBody,
  updatePlanBody,
  updatePlatformConfigBody,
  updatePricingPlanBody,
  voiceCallMinuteOps
} from "../chunk-2FCLSQSQ.js";
import {
  TURN_DEADLINE_SECONDS_FLOOR,
  TURN_DEADLINE_SECONDS_MAX
} from "../chunk-FECLIZTY.js";
import {
  MOBILE_APP_VERSION_RE,
  MOBILE_PLATFORMS,
  MOBILE_VERSION_POLICY_COLUMNS,
  isMobileAppVersionBelow,
  mobileAppVersionSchema,
  mobilePlatformSchema,
  mobileVersionPolicyQuery,
  mobileVersionPolicyResponse,
  mobileVersionPolicySchema,
  parseMobileAppVersion
} from "../chunk-BFG4ZWR4.js";
import {
  DEBUG_READ_DEFAULT_LIMIT,
  DEBUG_READ_MAX_LIMIT,
  dataExplorerDebugDoType
} from "../chunk-WO37XYVD.js";
import {
  CONTACT_ACCESS_PAGE_SIZE_DEFAULT,
  CONTACT_ACCESS_PAGE_SIZE_MAX,
  CONTACT_ACCESS_PREVIEW_CHARS,
  DEFAULT_ENDED_INDEX_RETENTION_DAYS,
  HUB_DIFF_SECTIONS,
  HUB_TAG_CHANGE_REFUSED,
  HUB_USERS_CHANNEL_TYPES,
  HUB_USERS_PAGE_SIZE_DEFAULT,
  HUB_USERS_PAGE_SIZE_MAX,
  HUB_USERS_SEARCH_MAX,
  HUB_USER_DISPLAY_NAME_CHARS,
  HUB_USER_NAMES_MAX_IDS,
  MAX_ENDED_INDEX_RETENTION_DAYS,
  MAX_END_USER_DAILY_MESSAGE_LIMIT,
  MAX_EVAL_RETENTION_DAYS,
  PREVIEW_LABEL_MAX_LENGTH,
  addHubAdminBody,
  addHubIdentityAuthorizationBody,
  addHubTeamUserBody,
  approveContactBody,
  claimCodeChannelParam,
  claimCodeDeleteParam,
  contactDecisionBody,
  createHubBody,
  createHubTeamBody,
  describeSyncWarning,
  endUserDailyMessageLimitField,
  getHubUsersQuery,
  hubAdminIdParam,
  hubIdParam,
  hubIdentityIdParam,
  hubSchemaQuery,
  hubTagChangeRefusalSchema,
  hubTeamIdParam,
  hubTeamUserDeleteParam,
  hubUserIdParam,
  listContactAccessQuery,
  reassignHubUserBody,
  replicatePreviewBody,
  syncWarningsField,
  updateChannelTestIdentitiesBody,
  updateHubBody,
  updateHubTeamBody
} from "../chunk-T4Q5COKJ.js";
import {
  addOrgAdminBody,
  createOrganizationBody,
  orgAdminIdParam,
  orgIdParam,
  primaryRegionSchema,
  updateOrganizationBody
} from "../chunk-3VHMUK4W.js";
import {
  EVENT_RELATIVE_FOLLOWUP_TYPES,
  SELECTABLE_FOLLOWUP_TYPES,
  followupTimeUnitSchema,
  followupTypeSchema,
  getEligibleKanbanOutcomes,
  isEventRelativeFollowupType,
  kanbanStatusesArraySchema,
  lintKanbanStatuses,
  validateLaneReferences
} from "../chunk-AMG6HKUQ.js";
import {
  HUB_DISPLAY_NAME_MAX_CHARS,
  HUB_PRESENTATION_FIELDS,
  HUB_PRESENTATION_SCHEMAS,
  HUB_STARTER_QUESTIONS_MAX,
  HUB_STARTER_QUESTION_MAX_CHARS,
  HUB_WELCOME_MESSAGE_MAX_CHARS,
  hubDisplayNamesField,
  hubDisplayNamesSchema,
  hubStarterQuestionsField,
  hubStarterQuestionsSchema,
  hubWelcomeMessagesField,
  hubWelcomeMessagesSchema,
  readHubDisplayNames,
  readHubPresentation,
  readHubStarterQuestions,
  readHubWelcomeMessages,
  resolveHubDisplayName,
  resolveHubPresentation
} from "../chunk-ACN6GXU6.js";
import {
  DATA_OPS_LOOKUP_KEY_PREFIX,
  DATA_OPS_METER_EVENT_NAME,
  DATA_OPS_OVERAGE_CEILING_MULTIPLIER,
  DATA_OPS_TENTHS_PER_OP,
  REKOR_ENTITLEMENT_CONTRACT_VERSION,
  REKOR_ENTITLEMENT_KEY_PREFIX,
  billingOrgIdParam,
  billingPlanTypeSchema,
  billingStatusSchema,
  changeTierBody,
  checkoutSessionBody,
  dataOpsFromTenths,
  dataOpsOverageQuantity,
  dataUsageCountersSchema,
  effectivePackQuantity,
  effectivePlanKey,
  entitlementProjectionSchema,
  growthPacksBody,
  invoicesQuery,
  isDataOpsMeteredOrg,
  isOperationsQuotaEnforced,
  isRollingWindowPlanType,
  isStrandedPaidRow,
  isStripeBilledPlan,
  normalizeBillingStatus,
  paidTierSchema,
  planAllowanceValue,
  planKeySchema,
  portalSessionBody,
  projectedOpsTenthsIncluded,
  rekorEntitlementRefreshMessageSchema,
  resolveDataAllowanceTotals,
  resolveEffectivePlan,
  spendCapBody,
  subscriptionItemParams,
  updateBillingCurrencyBody
} from "../chunk-OMPT4ZHR.js";
import {
  CATEGORICAL_FILTER_OPS,
  DEFAULT_EVALUATOR_VARIABLES,
  NUMERIC_FILTER_OPS,
  STRUCTURED_QUERY_AGGREGATIONS,
  STRUCTURED_QUERY_OPS,
  TEXT_FILTER_OPS,
  VARIABLE_FILTER_OPS,
  analyticsConversationIdParam,
  analyticsDataBody,
  analyticsHubIdParam,
  analyticsSqlBody,
  analyticsSqlSchemaQuery,
  analyticsSqlTable,
  analyticsVariableIdParam,
  conversationDetailDataQuery,
  conversationsBody,
  messagesQuery,
  structuredQueryBody,
  updateAnalyticsViewBody,
  updateVariablePinBody
} from "../chunk-2PZIF56U.js";
import {
  TASK_TITLE_VOICE,
  isVoiceTaskTitle
} from "../chunk-SOJMWM63.js";
import "../chunk-WEXVYJ5H.js";
import {
  evalDateContextSchema
} from "../chunk-LZDVDC2S.js";
import {
  AUTOMATION_WEBHOOK_MOUNT,
  BASE_DESTRUCTION_CONFIRM_PATH,
  BASE_DESTRUCTION_MOUNT,
  BASE_DESTRUCTION_PREFIX,
  COMMUNITY_EMAIL_UNSUBSCRIBE_PATH,
  CONTACT_BOOK_EMAIL_UNSUBSCRIBE_PATH,
  DATA_PROXY_MOUNT,
  DATA_PROXY_PREFIX
} from "../chunk-F3JHI4Y4.js";
import "../chunk-IBL7FANV.js";
import {
  PREVIOUS_CONVERSATIONS_MAX,
  clampPreviousConversationsCount
} from "../chunk-PFDZEKDE.js";
import "../chunk-VORPHGDT.js";
import {
  MAX_ATTACHMENTS_PER_MESSAGE,
  MAX_AUDIO_FILE_BASE64_BYTES,
  MAX_MESSAGE_BODY_BYTES,
  USER_ID_REGEX,
  attachmentsFitOneMessage,
  clientOptionalBoolean,
  clientOptionalNumber,
  clientOptionalString,
  idParamSchema,
  isAudioAttachmentFileName,
  messageAttachment,
  timestampSchema,
  uuidSchema
} from "../chunk-HZ6CADSY.js";
import "../chunk-MIWZOSPI.js";
import "../chunk-2ISUBJG7.js";
import {
  FLAG_CONDITION_OPERATORS
} from "../chunk-C2UEA2KW.js";
import "../chunk-6NI5RAM4.js";
import "../chunk-CJ3L46X6.js";
import "../chunk-6TSQ5HXC.js";
import "../chunk-DHPUPI4Y.js";
import "../chunk-T7KQKDET.js";
import "../chunk-L5F7ZOUJ.js";
import {
  END_USER_DAILY_LIMIT_CODE
} from "../chunk-TS4EYU3W.js";
import "../chunk-R7VSUKKX.js";
export {
  ACTIVE_LIST_DEFAULT_LIMIT,
  ACTIVE_LIST_MAX_LIMIT,
  ADMIN_PEOPLE_ACTIONS_MAX,
  ADMIN_PEOPLE_REPORTS_PAGE_DEFAULT,
  ADMIN_PEOPLE_REPORTS_PAGE_MAX,
  ADMIN_SKILL_NAME_REGEX,
  AGENT_PARAMETER_NAME_REGEX,
  APPEARANCE_MODES,
  APP_MESSAGE_CONVERSATION_ID_HEADER,
  ATTACHMENTS_USER_ONLY_MESSAGE,
  AUTOMATIONS_PER_HUB_MAX,
  AUTOMATION_ACTION_CHANNELS,
  AUTOMATION_ACTION_FIELDS,
  AUTOMATION_ACTION_TYPES,
  AUTOMATION_ALERT_CATEGORIES,
  AUTOMATION_BLOCKED_ALERT_CATEGORY,
  AUTOMATION_CHAIN_MAX_DEPTH,
  AUTOMATION_CHANNEL_TYPES,
  AUTOMATION_CRON_MAX,
  AUTOMATION_DESCRIPTION_MAX,
  AUTOMATION_EVENT_SUBSCRIPTIONS_PER_HUB_MAX,
  AUTOMATION_EVENT_TYPES,
  AUTOMATION_GATE_DECISIONS,
  AUTOMATION_GATE_EVALUATIONS_PER_OPERATION_BOUND,
  AUTOMATION_GATE_TRIGGERS,
  AUTOMATION_INSTRUCTIONS_MAX,
  AUTOMATION_ITEM_GATE_DECISIONS,
  AUTOMATION_NAME_MAX,
  AUTOMATION_PURPOSES,
  AUTOMATION_RUNS_PAGE_MAX,
  AUTOMATION_RUN_ERROR_CODES,
  AUTOMATION_RUN_RETENTION_DAYS_MAX,
  AUTOMATION_RUN_STATUSES,
  AUTOMATION_TARGET_TYPES,
  AUTOMATION_TEXT_MAX,
  AUTOMATION_TRIGGER_TYPES,
  AUTOMATION_WEBHOOK_AUTHS,
  AUTOMATION_WEBHOOK_BODY_MAX_BYTES,
  AUTOMATION_WEBHOOK_DEDUPE_KEY_MAX,
  AUTOMATION_WEBHOOK_HEADERS,
  AUTOMATION_WEBHOOK_HEADER_NAME_MAX,
  AUTOMATION_WEBHOOK_MAX_SKEW_SECONDS,
  AUTOMATION_WEBHOOK_MOUNT,
  BASE_CREDENTIAL_MANAGED_BY,
  BASE_CREDENTIAL_NAME_MAX,
  BASE_DESTRUCTION_CONFIRM_MESSAGES,
  BASE_DESTRUCTION_CONFIRM_PATH,
  BASE_DESTRUCTION_CONFIRM_TTL_MS,
  BASE_DESTRUCTION_GRACE_MS,
  BASE_DESTRUCTION_MOUNT,
  BASE_DESTRUCTION_ORG_QUERY_PARAM,
  BASE_DESTRUCTION_PREFIX,
  BASE_DESTRUCTION_TOKEN_QUERY_PARAM,
  BRANCHING_ORPHAN_ENTITY_TYPES,
  BRANCHING_ORPHAN_MAX_REFERENCES_SHOWN,
  BRANCHING_ORPHAN_MAX_TARGETS,
  CACHE_RECONCILE_MAX_HUBS,
  CACHE_RECONCILE_MAX_IDS,
  CALL_END_REASONS,
  CALL_MAX_STEERS_PER_CALL,
  CALL_OPENINGS_SEGMENT,
  CALL_OPENING_CAPTION_MAX_CHARS,
  CALL_OPENING_CONTENT_TYPES,
  CALL_OPENING_HASH_REGEX,
  CALL_OPENING_LANGUAGES,
  CALL_OPENING_MAX_BYTES,
  CALL_OPENING_MAX_DURATION_MS,
  CALL_PARTICIPANT_TYPES,
  CALL_REFUSAL_REASONS,
  CALL_STATUSES,
  CALL_STEERING_MIN_CONFIDENCE,
  CALL_TRANSPORTS,
  CALL_UTTERANCE_CHECK_CHARS,
  CALL_UTTERANCE_MAX_RUNS_PER_CALL,
  CALL_UTTERANCE_SPEAKERS,
  CALL_UTTERANCE_SPEAKER_DEFAULT,
  CATEGORICAL_FILTER_OPS,
  CI_APPLY_ENTITY_KINDS,
  CI_APPLY_ERROR_CLASSIFICATIONS,
  CI_APPLY_OPERATIONS,
  COMMUNITIES_PER_ORG_MAX,
  COMMUNITIES_PER_ORG_REASON,
  COMMUNITIES_PER_PERSON_MAX,
  COMMUNITIES_PER_PERSON_REASON,
  COMMUNITY_ACCESS_ADD_MAX,
  COMMUNITY_ACCESS_FULL_REASON,
  COMMUNITY_ACCESS_MAX,
  COMMUNITY_ACCESS_PAGE_SIZE,
  COMMUNITY_ADMISSIONS,
  COMMUNITY_ANNOUNCEMENTS_LIMIT,
  COMMUNITY_ANNOUNCEMENTS_PER_DAY,
  COMMUNITY_ANNOUNCEMENT_PUSH_KIND,
  COMMUNITY_ATTACHMENT_MAX_BYTES,
  COMMUNITY_ATTACHMENT_TYPES,
  COMMUNITY_ATTACHMENT_TYPE_REASON,
  COMMUNITY_ATTACHMENT_URLS_MAX,
  COMMUNITY_ATTACHMENT_URL_TTL_SECONDS,
  COMMUNITY_COURSES_LABEL_MAX_LENGTH,
  COMMUNITY_COURSES_MAX,
  COMMUNITY_COURSES_REASON,
  COMMUNITY_COURSE_DESCRIPTION_MAX_LENGTH,
  COMMUNITY_COURSE_LESSONS_MAX,
  COMMUNITY_COURSE_LESSONS_REASON,
  COMMUNITY_COURSE_MODULES_MAX,
  COMMUNITY_COURSE_MODULES_REASON,
  COMMUNITY_COURSE_TITLE_MAX_LENGTH,
  COMMUNITY_DAILY_LIMIT,
  COMMUNITY_EMAIL_UNSUBSCRIBE_PAGE_PATH,
  COMMUNITY_EMAIL_UNSUBSCRIBE_PATH,
  COMMUNITY_FULL_REASON,
  COMMUNITY_JOIN_FLOW_TOKEN_MAX_LENGTH,
  COMMUNITY_JOIN_SOURCE_MAX_LENGTH,
  COMMUNITY_LESSONS_MAX,
  COMMUNITY_LESSONS_REASON,
  COMMUNITY_LESSON_BODY_MAX_LENGTH,
  COMMUNITY_LESSON_CONTAINER_PREFIX_MAX_COLUMNS,
  COMMUNITY_LESSON_LINE_PREFIX_TOO_WIDE_REASON,
  COMMUNITY_LESSON_LINKS_MAX,
  COMMUNITY_LESSON_LINK_PROTOCOLS,
  COMMUNITY_LESSON_PROGRESS_REASON,
  COMMUNITY_LESSON_TREE_MAX_BYTES,
  COMMUNITY_LESSON_TREE_MAX_DEPTH,
  COMMUNITY_LESSON_TREE_TOO_DEEP_REASON,
  COMMUNITY_LESSON_TREE_TOO_LARGE_REASON,
  COMMUNITY_LESSON_TREE_VERSION,
  COMMUNITY_LESSON_URL_MAX_LENGTH,
  COMMUNITY_LESSON_VIDEO_PROVIDERS,
  COMMUNITY_LIVE_CLOSE_ENDED,
  COMMUNITY_LIVE_CLOSE_EXPIRED,
  COMMUNITY_LIVE_CLOSE_OFF,
  COMMUNITY_LIVE_MESSAGES_LIMIT,
  COMMUNITY_LIVE_MESSAGES_MAX,
  COMMUNITY_LIVE_SOCKETS_MAX,
  COMMUNITY_LIVE_SOCKETS_PER_PERSON_MAX,
  COMMUNITY_LIVE_SOCKET_MAX_AGE_SECONDS,
  COMMUNITY_LIVE_TICKET_PREFIX,
  COMMUNITY_LIVE_TICKET_TTL_SECONDS,
  COMMUNITY_MEMBERS_MAX,
  COMMUNITY_MEMBER_MESSAGES_PER_DAY,
  COMMUNITY_MEMBER_ROLES,
  COMMUNITY_MEMBER_STATUSES,
  COMMUNITY_MESSAGES_PAGE_SIZE,
  COMMUNITY_MESSAGES_PER_SECOND,
  COMMUNITY_MESSAGE_MAX_LENGTH,
  COMMUNITY_MOD_ACTIONS_MAX,
  COMMUNITY_MOD_ACTIONS_PAGE_SIZE,
  COMMUNITY_MOD_ACTION_KINDS,
  COMMUNITY_NAME_MAX_LENGTH,
  COMMUNITY_NEW_MEMBER_MESSAGES_PER_DAY,
  COMMUNITY_NOT_A_POST_REASON,
  COMMUNITY_NOT_INVITED_REASON,
  COMMUNITY_NOT_JOINED_REASON,
  COMMUNITY_PEOPLE_PAGE_SIZE,
  COMMUNITY_PINS_PER_ROOM_MAX,
  COMMUNITY_PINS_REASON,
  COMMUNITY_POSTS_PAGE_SIZE,
  COMMUNITY_POST_LOCKED_REASON,
  COMMUNITY_POST_PREVIEW_LENGTH,
  COMMUNITY_POST_SEARCH_MAX_LENGTH,
  COMMUNITY_POST_TITLE_MAX_LENGTH,
  COMMUNITY_PROGRESS_COMMUNITIES_MAX,
  COMMUNITY_RANK_REASON,
  COMMUNITY_RATE_LIMIT,
  COMMUNITY_REGISTRY_CLOSED_REASON,
  COMMUNITY_REPLY_PUSH_KIND,
  COMMUNITY_REPORTS_MAX,
  COMMUNITY_REPORTS_PAGE_SIZE,
  COMMUNITY_ROOMS_MAX,
  COMMUNITY_ROOMS_REASON,
  COMMUNITY_ROOM_ARCHIVED_REASON,
  COMMUNITY_ROOM_KIND_REASON,
  COMMUNITY_ROOM_NAME_MAX_LENGTH,
  COMMUNITY_RULES_MAX_LENGTH,
  COMMUNITY_SLOW_MODE_LIMIT,
  COMMUNITY_SLOW_MODE_MAX_SECONDS,
  COMMUNITY_STATS_DAYS,
  COMMUNITY_STATS_SOURCES_MAX,
  COMMUNITY_VIEWER_ROLES,
  CONSULT_AWAIT_TIMEOUT_MS,
  CONSULT_MAX_DEPTH,
  CONSULT_MAX_PER_COMPLETION,
  CONSULT_MAX_PER_CONVERSATION,
  CONSULT_SYNC_TURN_BUDGET_MS,
  CONSULT_SYSTEM_EVENTS,
  CONSULT_TEAM_TAKEOVER_NOTICE,
  CONSULT_THREAD_STATUSES,
  CONTACT_ACCESS_PAGE_SIZE_DEFAULT,
  CONTACT_ACCESS_PAGE_SIZE_MAX,
  CONTACT_ACCESS_PREVIEW_CHARS,
  CONTACT_BOOK_CONTACTS_MAX,
  CONTACT_BOOK_EMAIL_UNSUBSCRIBE_PAGE_PATH,
  CONTACT_BOOK_EMAIL_UNSUBSCRIBE_PATH,
  CONTACT_BOOK_REFUSALS,
  CONTACT_EMAIL_MAX,
  CONTACT_ENVIRONMENTS,
  CONTACT_IMPORT_BATCH_MAX,
  CONTACT_INSTAGRAM_SID_MAX,
  CONTACT_LABELS_MAX,
  CONTACT_LABEL_MAX,
  CONTACT_LINK_CANDIDATES_MAX,
  CONTACT_LISTS_MAX,
  CONTACT_LIST_DESCRIPTION_MAX,
  CONTACT_LIST_FILTER_MAX,
  CONTACT_LIST_NAME_MAX,
  CONTACT_LIST_NAME_REGEX,
  CONTACT_LIST_PINS_MAX,
  CONTACT_LIST_PINS_PER_REQUEST_MAX,
  CONTACT_METADATA_MAX_BYTES,
  CONTACT_NAME_MAX,
  CONTACT_PAGE_MAX,
  CONTACT_PHONE_INPUT_MAX,
  CONTACT_SCOPE_TAGS_MAX,
  CONTACT_SEARCH_MAX,
  CONTEXT_BOUNDARIES,
  DATA_BASE_GENERATION_HEADER,
  DATA_FILE_UPLOAD_HEADERS,
  DATA_OPS_LOOKUP_KEY_PREFIX,
  DATA_OPS_METER_EVENT_NAME,
  DATA_OPS_OVERAGE_CEILING_MULTIPLIER,
  DATA_OPS_TENTHS_PER_OP,
  DATA_PROXY_MOUNT,
  DATA_PROXY_ORG_QUERY_PARAM,
  DATA_PROXY_PREFIX,
  DEBUG_DO_HEX_PREFIX,
  DEBUG_READ_DEFAULT_LIMIT,
  DEBUG_READ_MAX_LIMIT,
  DEFAULT_APPEARANCE,
  DEFAULT_AUTOMATION_PURPOSE,
  DEFAULT_CONTEXT_BOUNDARY,
  DEFAULT_ENDED_INDEX_RETENTION_DAYS,
  DEFAULT_EVALUATOR_VARIABLES,
  DESKTOP_APP_PATH_MAX_LENGTH,
  DESKTOP_BADGE_LABEL_MAX_LENGTH,
  DESKTOP_BADGE_MAX_COUNT,
  DESKTOP_BRIDGE_CHANNELS,
  DESKTOP_BRIDGE_EVENTS,
  DESKTOP_BRIDGE_GLOBAL,
  DESKTOP_BRIDGE_VERSION,
  DESKTOP_FLAVORS,
  DESKTOP_NOTIFICATION_BODY_MAX_LENGTH,
  DESKTOP_NOTIFICATION_KINDS,
  DESKTOP_NOTIFICATION_TITLE_MAX_LENGTH,
  DESKTOP_PLATFORMS,
  DESKTOP_PRESENCE_STATES,
  DESKTOP_SHELL_VERSION_RE,
  DESKTOP_SIGN_IN_MAX_AGE_SECONDS,
  DESKTOP_SIGN_IN_URL_MAX_LENGTH,
  DIAGNOSTIC_CODES,
  END_USER_DAILY_LIMIT_CODE,
  EVAL_ATTACHMENT_HASH_REGEX,
  EVAL_CALL_MAX_SECONDS,
  EVAL_CALL_MIN_SECONDS,
  EVAL_CALL_RECORD_MAX_REPLY_CHARS,
  EVAL_CALL_RECORD_MAX_TURNS,
  EVAL_CALL_RECORD_MAX_UTTERANCES,
  EVAL_CALL_SPOKEN_LINE_MAX_CHARS,
  EVAL_FIXTURE_NAME_MAX_LENGTH,
  EVAL_INITIAL_STATE_SCOPES,
  EVAL_INPUT_ROLES,
  EVAL_LIST_MAX_LIMIT,
  EVAL_MAX_SELECTED_SCENARIOS,
  EVAL_RUN_ERROR_KINDS,
  EVAL_RUN_OUTCOME_KINDS,
  EVAL_SESSION_NOT_QUIESCENT,
  EVENT_RELATIVE_FOLLOWUP_TYPES,
  FLAG_CONDITION_OPERATORS,
  GITHUB_ISSUE_URL_REGEX,
  GUIDE_HUB_INELIGIBLE_REASON,
  HUB_AS_CODE_AGENT_KEYS,
  HUB_AS_CODE_AGENT_TOOL_KEYS,
  HUB_AS_CODE_AUTOMATION_ACTION_KEYS,
  HUB_AS_CODE_AUTOMATION_GATE_KEYS,
  HUB_AS_CODE_AUTOMATION_KEYS,
  HUB_AS_CODE_AUTOMATION_TARGET_KEYS,
  HUB_AS_CODE_AUTOMATION_TRIGGER_KEYS,
  HUB_AS_CODE_CONTACT_LIST_FILTER_KEYS,
  HUB_AS_CODE_CONTACT_LIST_KEYS,
  HUB_CONTACT_LISTS_MAX,
  HUB_CONTACT_LIST_REFUSALS,
  HUB_DIFF_SECTIONS,
  HUB_DISPLAY_NAME_MAX_CHARS,
  HUB_LIST_FILTER_REQUIRED,
  HUB_PRESENTATION_FIELDS,
  HUB_PRESENTATION_SCHEMAS,
  HUB_STARTER_QUESTIONS_MAX,
  HUB_STARTER_QUESTION_MAX_CHARS,
  HUB_TAG_CHANGE_REFUSED,
  HUB_USERS_CHANNEL_TYPES,
  HUB_USERS_PAGE_SIZE_DEFAULT,
  HUB_USERS_PAGE_SIZE_MAX,
  HUB_USERS_SEARCH_MAX,
  HUB_USER_DISPLAY_NAME_CHARS,
  HUB_USER_NAMES_MAX_IDS,
  HUB_WELCOME_MESSAGE_MAX_CHARS,
  INSERT_NOTE_TOOL_NAME,
  MAX_10MB_BASE64_ENCODED_BYTES,
  MAX_ATTACHMENTS_PER_MESSAGE,
  MAX_AUDIO_FILE_BASE64_BYTES,
  MAX_CALL_OPENING_AGGREGATE_ENCODED_BYTES,
  MAX_CALL_OPENING_BODY_BYTES,
  MAX_CALL_OPENING_CARRIERS,
  MAX_CALL_OPENING_ENCODED_BYTES,
  MAX_CALL_RECORDING_GAPS,
  MAX_CALL_REQUEST_BODY_BYTES,
  MAX_CI_CONFIG_BODY_BYTES,
  MAX_ENDED_INDEX_RETENTION_DAYS,
  MAX_END_USER_DAILY_MESSAGE_LIMIT,
  MAX_EVAL_ATTACHMENT_AGGREGATE_ENCODED_BYTES,
  MAX_EVAL_ATTACHMENT_CARRIERS,
  MAX_EVAL_ATTACHMENT_ENCODED_BYTES,
  MAX_EVAL_RETENTION_DAYS,
  MAX_HUB_AS_CODE_RESOURCES,
  MAX_HUB_AS_CODE_RESOURCE_FILES,
  MAX_INITIAL_STATE_ENTRIES,
  MAX_MESSAGE_BODY_BYTES,
  MAX_PROVISIONING_BODY_BYTES,
  MAX_REKOR_TOOL_ID_LENGTH,
  MAX_REPORTED_DELEGATION_IDS,
  MAX_RESOURCE_AGGREGATE_ENCODED_BYTES,
  MAX_RESOURCE_ENCODED_BYTES,
  MAX_SDP_OFFER_LENGTH,
  MAX_VOICE_CALL_MINUTE_OPS,
  META_ENTITY_ID_PATTERN,
  MOBILE_APP_VERSION_RE,
  MOBILE_PLATFORMS,
  MOBILE_VERSION_POLICY_COLUMNS,
  MONITOR_AUTOMATION_FIRE_ACTION_KINDS,
  MONITOR_AUTOMATION_ITEM_ACTION_KINDS,
  MONITOR_CASCADE_MAX_DEPTH,
  MONITOR_DELAY_SECONDS_MIN,
  MONITOR_FIRING_TRIGGERS,
  MONITOR_GATE_AGENT_NAME_MAX,
  MONITOR_HISTORY_MESSAGES_DEFAULT,
  MONITOR_HISTORY_MESSAGES_MAX,
  MONITOR_NOTE_RENDERED_MAX,
  MONITOR_RULE_ALLOWED_NATIVE_TOOLS,
  MONITOR_RULE_TRIGGERS,
  MONITOR_RULE_TRIGGER_MESSAGE,
  MONITOR_STEER_NOTE_MAX,
  MONITOR_TRIGGERS,
  NOTICE_SCOPE_REGEX,
  NUMERIC_FILTER_OPS,
  ORG_TAG_NAME_MAX_LENGTH,
  ORG_TAG_NAME_REGEX,
  PEOPLE_ATTACHMENT_STORAGE_LIMIT,
  PEOPLE_ATTACHMENT_STORAGE_PER_USER_BYTES,
  PEOPLE_CONTACTS_MAX,
  PEOPLE_CONTACT_BLOCKS_MAX,
  PEOPLE_CONTACT_DECLINE_SUPPRESSION_DAYS,
  PEOPLE_CONTACT_EMAIL_MAX_LENGTH,
  PEOPLE_CONTACT_INCOMING_INVITES_MAX,
  PEOPLE_CONTACT_INVITES_PER_DAY,
  PEOPLE_CONTACT_INVITE_TTL_DAYS,
  PEOPLE_CONTACT_OUTGOING_INVITES_MAX,
  PEOPLE_CONTACT_PAGE_DEFAULT,
  PEOPLE_CONTACT_PAGE_MAX,
  PEOPLE_GROUP_AVATAR_URL_MAX_LENGTH,
  PEOPLE_GROUP_INCOMING_INVITES_MAX,
  PEOPLE_GROUP_INVITES_PER_ADMIN_MAX,
  PEOPLE_GROUP_MEMBERS_MAX,
  PEOPLE_GROUP_NAME_MAX_LENGTH,
  PEOPLE_LIVE_FRAME_TYPES,
  PEOPLE_MODERATION_NOTE_MAX_LENGTH,
  PEOPLE_ORG_ERASURES_PER_DAY,
  PEOPLE_ORG_ERASURE_PAGE,
  PEOPLE_ORG_ROLE_CHECK_MAX,
  PEOPLE_REPORTS_PER_DAY,
  PEOPLE_REPORT_CONTEXT_MESSAGES,
  PEOPLE_REPORT_DETAILS_MAX_LENGTH,
  PEOPLE_SUSPENDED_REASON,
  PEOPLE_THREAD_ATTACHMENT_MAX_BYTES,
  PEOPLE_THREAD_ATTACHMENT_MAX_MB,
  PEOPLE_THREAD_ATTACHMENT_NAME_MAX_LENGTH,
  PEOPLE_THREAD_ATTACHMENT_URLS_MAX,
  PEOPLE_THREAD_ATTACHMENT_URL_TTL_SECONDS,
  PEOPLE_THREAD_DELIVERIES_PER_DAY,
  PEOPLE_THREAD_HEAD_MAX,
  PEOPLE_THREAD_INLINE_IMAGE_TYPES,
  PEOPLE_THREAD_MESSAGES_PAGE_MAX,
  PEOPLE_THREAD_MESSAGE_MAX_LENGTH,
  PEOPLE_THREAD_PAGE_DEFAULT,
  PEOPLE_THREAD_PAGE_MAX,
  PEOPLE_THREAD_PREVIEW_MAX_LENGTH,
  PEOPLE_THREAD_PUSH_KIND,
  PREVIEW_LABEL_MAX_LENGTH,
  PREVIOUS_CONVERSATIONS_MAX,
  REKOR_ACTOR_ADMIN_HEADER,
  REKOR_ACTOR_ID_HEADER,
  REKOR_ACTOR_LABEL_HEADER,
  REKOR_ACTOR_ORG_HEADER,
  REKOR_ACTOR_TYPE_HEADER,
  REKOR_BASE_INCARNATION_MISMATCH,
  REKOR_BINDING_ORIGIN,
  REKOR_BOUND_BASE_HEADER,
  REKOR_BOUND_CUSTOMER_HEADER,
  REKOR_BOUND_TOKEN_HEADER,
  REKOR_BOUND_TOOLSET_HEADER,
  REKOR_CLIENTS,
  REKOR_CLIENT_HEADER,
  REKOR_CUSTOMER_SCOPE_MISMATCH,
  REKOR_CUSTOMER_SCOPE_REQUIRED,
  REKOR_ENTITLEMENT_CONTRACT_VERSION,
  REKOR_ENTITLEMENT_KEY_PREFIX,
  REKOR_INLINE_PROJECTION_BODY_KEY,
  REKOR_LIFECYCLE_PREFIX,
  REKOR_MAX_ACTOR_ID_LENGTH,
  REKOR_MAX_ACTOR_LABEL_LENGTH,
  REKOR_STRUCTURAL_ID_PATTERN,
  REKOR_TOOL_ID_HEADER,
  REKOR_TOOL_NOT_FOUND,
  REKOR_V1_PREFIX,
  REPORT_CONTEST_CAP,
  REPORT_TERMINAL_STATUSES,
  REQUIRED_REKOR_ATTESTATION_HEADERS,
  RUN_MONITOR_TOOL_NAME,
  RUN_SESSION_ERRORS,
  SEED_LEASE_WARNINGS,
  SELECTABLE_FOLLOWUP_TYPES,
  SERVER_OWNED_CONNECTION_SETTINGS,
  SIGN_URL_MAX_EXPIRES_IN_SECONDS,
  STRUCTURED_QUERY_AGGREGATIONS,
  STRUCTURED_QUERY_OPS,
  SUPPRESSION_IDENTITY_KINDS,
  SUPPRESSION_ID_REGEX,
  SUPPRESSION_SCOPES,
  SUPPRESSION_SOURCES,
  TASK_TITLE_VOICE,
  TEXT_FILTER_OPS,
  TOKEN_LIMITS,
  TOOLSET_BINDING_SETTING,
  TOOLSET_CATALOG_ONLY_REFUSAL,
  TOOLSET_CONNECTION_CHANGED_REFUSAL,
  TOOLSET_CUSTOMER_FACING_REFUSAL,
  TOOLSET_ENVIRONMENT_REFUSAL,
  TOOLSET_FILE_OPERATIONS,
  TOOLSET_SLUG_PATTERN,
  TOOLSET_SLUG_SETTING,
  TOOLSET_UNRESOLVED_CREDENTIAL_REFUSAL,
  TURN_DEADLINE_SECONDS_FLOOR,
  TURN_DEADLINE_SECONDS_MAX,
  USER_ID_REGEX,
  VARIABLE_FILTER_OPS,
  VAULT_LIMITS,
  WAYAI_ATTESTED_CLIENT,
  WAYAI_TOOL_ID_HEADER,
  WS_CLIENT_PING_FRAME,
  WS_CLOSE_HIDDEN_IDLE,
  WS_CLOSE_NETWORK_OFFLINE,
  WS_CLOSE_PROBE_TIMEOUT,
  WS_CLOSE_RX_TIMEOUT,
  WS_CLOSE_SERVER_IDLE_PARK,
  WS_CLOSE_SWEEP_TIMEOUT,
  WS_CLOSE_VISIBLE_IDLE,
  WS_SERVER_PONG_FRAME,
  activityQuery,
  addAdminUserBody,
  addConnectionBody,
  addHubAdminBody,
  addHubIdentityAuthorizationBody,
  addHubTeamUserBody,
  addMcpToolBody,
  addNativeToolBody,
  addOrgAdminBody,
  additionalContextPayloadSchema,
  adjustQuotaBody,
  adminCreateCommunityBody,
  adminHarnessMassDestroyBody,
  adminOrgAdminIdParam,
  adminOrgIdParam,
  adminOrganizationsQuery,
  adminPeopleMessageRemovalBody,
  adminPeopleNoteBody,
  adminPeopleReportIdParam,
  adminPeopleReportListQuery,
  adminPeopleSuspendBody,
  adminPeopleUserIdParam,
  adminPlanIdParam,
  adminRepairBranchingOrphansBody,
  adminRepairCompedPlansBody,
  adminRepairLegacyOrgGrantsBody,
  adminRepairTeamOrphansBody,
  adminScopedTargetBody,
  adminSetGuideHubBody,
  adminSkillNameParam,
  adminUserIdParam,
  adminUserSearchQuery,
  agentAssignedToolNames,
  agentCallOpeningParams,
  agentConnectionsQuery,
  agentIdParam,
  agentResourceQuery,
  agentTakesTaskTurn,
  analyticsConversationIdParam,
  analyticsDataBody,
  analyticsHubIdParam,
  analyticsSqlBody,
  analyticsSqlSchemaQuery,
  analyticsSqlTable,
  analyticsVariableIdParam,
  annotateConversationBody,
  apiChannelMessage,
  apiChannelMessageBody,
  appMessageBody,
  appMessageReceiverType,
  appMessageResponse,
  appMessageSenderType,
  appearanceFromDarkMode,
  applyStoredFileHeaders,
  approveContactBody,
  archiveConversationParams,
  archiveHubIdParam,
  archiveListQuery,
  archiveMessageObservabilityParams,
  asEvalInputRecord,
  attachmentsFitOneMessage,
  authMeResponse,
  automationActionFields,
  automationActionSchema,
  automationActionTypesFor,
  automationEventSubscriberParam,
  automationGateEvaluationsPerOperation,
  automationGateMonitorFactsOf,
  automationGateMonitorIssue,
  automationGateSchema,
  automationGateTriggerOf,
  automationHubQuery,
  automationIdParam,
  automationOpensTasks,
  automationRunRetentionDays,
  automationTakesChannel,
  automationTargetSchema,
  automationTargetTypesFor,
  automationTriggerSchema,
  automationTriggerTypesFor,
  automationWebhookHeaderIssue,
  automationWebhookParams,
  automationWebhookPath,
  baseCredentialLinkParams,
  baseCredentialLinkQuery,
  baseCredentialNameSchema,
  baseDestructionCancelResponse,
  baseDestructionConfirmBody,
  baseDestructionConfirmPath,
  baseDestructionConfirmResponse,
  baseDestructionConsolePath,
  baseDestructionInitiateBody,
  baseDestructionInitiateResponse,
  baseDestructionListResponse,
  baseDestructionParam,
  baseDestructionQuery,
  baseDestructionRequest,
  baseDestructionStatus,
  billingOrgIdParam,
  billingPlanTypeSchema,
  billingStatusSchema,
  bindingRefusedToCustomerFacing,
  bootstrapQuery,
  bulkToggleEvalsBody,
  cacheReconcileBody,
  cacheReconcileIdCount,
  cacheReconcileScopeSchema,
  cachedConversationPageSchema,
  cachedHistoryThreadSchema,
  cachedPeopleThreadSchema,
  callDelegationId,
  callDelegationsBody,
  callEndReason,
  callHangupBody,
  callIdParam,
  callOpeningCaption,
  callOpeningContentType,
  callOpeningHash,
  callOpeningLanguage,
  callOpeningParam,
  callOpeningQuery,
  callOpeningVersion,
  callParticipantType,
  callReadyBody,
  callRecordingGap,
  callRecordingNoteMetadata,
  callResponse,
  callStatus,
  callStatusQuery,
  callSteeringWriteNeedsGate,
  callSummary,
  callTransport,
  callUtteranceConfidenceNotDeclaredMessage,
  callUtteranceRuleConfident,
  changeTierBody,
  checkCallUtteranceConfidenceDeclared,
  checkMonitorCalleesRunnable,
  checkMonitorRuleToolsAssigned,
  checkoutSessionBody,
  ciApplyErrorSchema,
  ciBranchParam,
  ciBranchesQuery,
  ciDiffBody,
  ciHubsQuery,
  ciLookupQuery,
  ciOrgResourcesDiffBody,
  ciOrgResourcesParam,
  ciOrgResourcesPushBody,
  ciPublishBody,
  ciPublishPreviewBody,
  ciPullHubIdParam,
  ciPullQuery,
  ciPushBody,
  ciSyncBody,
  ciSyncChangesSchema,
  ciSyncMcpBody,
  ciSyncResponseSchema,
  ciSyncWarningSchema,
  claimBody,
  claimCodeChannelParam,
  claimCodeDeleteParam,
  clampMonitorConfigDelay,
  clampPreviousConversationsCount,
  clickhouseReadyResponse,
  clientOptionalBoolean,
  clientOptionalNumber,
  clientOptionalString,
  closeBody,
  collectMonitorRuleIssues,
  collectTurnAttachmentHashes,
  communityAccessAddBody,
  communityAccessEmailSchema,
  communityAccessIdParam,
  communityAccessQuery,
  communityAdmissionSchema,
  communityAnswerBody,
  communityAttachmentUploadSchema,
  communityAttachmentUrlsBody,
  communityBanBody,
  communityCourseCreateBody,
  communityCourseDescriptionSchema,
  communityCourseIdParam,
  communityCourseModuleIdParam,
  communityCoursePositionSchema,
  communityCourseTitleSchema,
  communityCourseUpdateBody,
  communityCoursesLabelSchema,
  communityEditBody,
  communityEmailUnsubscribeQuery,
  communityEmailUnsubscribeTokenSchema,
  communityIdParam,
  communityJoinBody,
  communityJoinPreviewQuery,
  communityJoinSourceSchema,
  communityJoinTokenSchema,
  communityLessonBodySchema,
  communityLessonCreateBody,
  communityLessonIdParam,
  communityLessonLinkSchema,
  communityLessonLinkUrl,
  communityLessonLinksSchema,
  communityLessonUpdateBody,
  communityLessonVideoEmbedUrl,
  communityLessonVideoUrlSchema,
  communityLessonVideoWatchUrl,
  communityLiveQuery,
  communityLiveTicketSchema,
  communityLockBody,
  communityMessageBodySchema,
  communityMessageIdParam,
  communityMessagesQuery,
  communityModLogQuery,
  communityModuleCreateBody,
  communityModuleUpdateBody,
  communityMuteBody,
  communityNameSchema,
  communityNextLessonId,
  communityOrgParam,
  communityOutlineLessonIds,
  communityPeopleQuery,
  communityPersonParam,
  communityPinBody,
  communityPostIdParam,
  communityPostTitleSchema,
  communityPostsQuery,
  communityReadBody,
  communityReportIdParam,
  communityReportsQuery,
  communityRoomCreateBody,
  communityRoomIdParam,
  communityRoomKindSchema,
  communityRoomNameSchema,
  communityRoomUnreadCount,
  communityRoomUpdateBody,
  communitySendBody,
  communitySettingsBody,
  communityUnreadCount,
  compareSessionsQuery,
  connectionIdParam,
  connectorIdParam,
  consultThreadIdParam,
  consultThreadStatus,
  consultThreadSummary,
  consultThreadTitle,
  contactBookContactParam,
  contactBookEmailUnsubscribeQuery,
  contactBookEmailUnsubscribeTokenSchema,
  contactBookHubParam,
  contactBookLinkCandidatesQuery,
  contactBookListParam,
  contactBookOrgQuery,
  contactBookPageQuery,
  contactBookSuppressionParam,
  contactDecisionBody,
  contactImportRowSchema,
  contactListFilterSchema,
  contactVisibilitySchema,
  contestReportBody,
  conversationDetailDataQuery,
  conversationHubQuery,
  conversationIdParam,
  conversationListResourcesQuery,
  conversationReadResourceQuery,
  conversationsBody,
  copilotSuggestBody,
  copilotSuggestResponse,
  createAgentBody,
  createAgentParametersBody,
  createAutomationBody,
  createBaseCredentialLinkBody,
  createCallBody,
  createCallResponse,
  createConsultThreadBody,
  createConsultThreadResponse,
  createContactBookContactBody,
  createContactBookListBody,
  createContactBookSuppressionBody,
  createCustomToolBody,
  createEvalBody,
  createEvalCallBody,
  createEvalCallResponse,
  createExperimentBody,
  createHubBody,
  createHubContactListBody,
  createHubTeamBody,
  createJourneyBody,
  createJourneyFromConversationBody,
  createNoticeBody,
  createOrgCredentialBody,
  createOrgResourceBody,
  createOrgResourceFolderBody,
  createOrgTagBody,
  createOrganizationBody,
  createReportBody,
  createResourceBody,
  createResourceFileBody,
  createResourceFolderBody,
  createScenarioFromConversationBody,
  createScenarioSetBody,
  createSessionBody,
  createStateBody,
  createTemplateBody,
  createTokenBody,
  createVariantBody,
  customerFacingRefusalText,
  darkModeForAppearance,
  dataExplorerConvIdParam,
  dataExplorerDebugAnalyticsRowsParam,
  dataExplorerDebugAnalyticsRowsQuery,
  dataExplorerDebugAnalyticsTable,
  dataExplorerDebugArchiveParam,
  dataExplorerDebugArchiveQuery,
  dataExplorerDebugDoType,
  dataExplorerDebugObservabilityParam,
  dataExplorerDebugObservabilityQuery,
  dataExplorerDebugRowsParam,
  dataExplorerDebugRowsQuery,
  dataExplorerDebugTablesParam,
  dataExplorerDeleteConvParam,
  dataExplorerDeleteHubParam,
  dataExplorerDeleteOrgParam,
  dataExplorerDeleteQuery,
  dataExplorerDeleteUserParam,
  dataExplorerDoInstancesQuery,
  dataExplorerHubIdParam,
  dataExplorerKvDeleteBody,
  dataExplorerKvKeyBody,
  dataExplorerKvKeysBody,
  dataExplorerNsIdParam,
  dataExplorerOrgIdParam,
  dataExplorerSearchQuery,
  dataOpsFromTenths,
  dataOpsOverageQuantity,
  dataProxyQuery,
  dataUsageCountersSchema,
  decodedMonitorConfig,
  deleteAgentCallOpeningQuery,
  deleteConnectionQuery,
  deleteOverrideQuery,
  deletePushTokenQuery,
  deleteTemplateQuery,
  deleteToolQuery,
  deleteUserConversationsBody,
  deleteUserConversationsResponse,
  deletionModeSchema,
  deletionRequestBody,
  deriveEvalRunOutcomeKind,
  describeSyncWarning,
  desktopAppPathSchema,
  desktopBadgeSchema,
  desktopBridgeArgsSchemas,
  desktopNavigateSchema,
  desktopNotificationSchema,
  desktopPresenceSchema,
  desktopSettingsChangeSchema,
  desktopSettingsSchema,
  desktopShellInfoSchema,
  desktopShowsCustomerWords,
  desktopUpdateSchema,
  downloadBody,
  editConnectionBody,
  editReportBody,
  effectivePackQuantity,
  effectivePlanKey,
  endUserDailyMessageLimitField,
  entitlementProjectionSchema,
  evalAnalyticsQuery,
  evalAttachmentRef,
  evalCallBody,
  evalCallConversationQuery,
  evalCallFinishBody,
  evalCallFinishResponse,
  evalCallRecordQuery,
  evalCallRecordResponse,
  evalCallRecording,
  evalCallSpeaker,
  evalCallTurn,
  evalCallUtterance,
  evalCallWebPath,
  evalCustomerContactIdError,
  evalCustomerContactIdSchema,
  evalDateContextSchema,
  evalFixtureOverrideSchema,
  evalIdParam,
  evalInitialStateEntry,
  evalInitialStateError,
  evalInputRoleError,
  evalNameError,
  evalScenarioSelectionEntrySchema,
  evalScenarioSelectionSchema,
  evalSeedStateUserId,
  evalSessionConfigResponseSchema,
  evalSessionListConfigSchema,
  evalSessionListItemSchema,
  evalSessionResponseSchema,
  evalTurnAttachmentsError,
  evalsSqlBody,
  evalsSqlSchemaQuery,
  evaluatedRunCount,
  experimentIdParam,
  exportResultsQuery,
  filterNamesAnything,
  followupTimeUnitSchema,
  followupTypeSchema,
  getConversationDetailParams,
  getConversationDetailQuery,
  getConversationDetailResponse,
  getConversationsQuery,
  getConversationsResponse,
  getEligibleKanbanOutcomes,
  getEvalsQuery,
  getHubUserContextResponse,
  getHubUsersQuery,
  getMessagesQuery,
  getReportEditRejection,
  getReportHoldRejection,
  getReportRecurrenceOutcome,
  getReportResponseSchema,
  getReportTransitionRejection,
  getSessionCostQuery,
  getSessionResultsQuery,
  getSessionRunsQuery,
  getSessionsQuery,
  groupReportsBody,
  growthPacksBody,
  healthSamplingTriggerBody,
  holdReportBody,
  hubAdminIdParam,
  hubAgentsQuery,
  hubAlert,
  hubAlertSeverity,
  hubAlertsListResponse,
  hubAlertsParam,
  hubAsCodeResourceFileSchema,
  hubAsCodeResourceSchema,
  hubAsCodeStateSchema,
  hubContactListFilterSchema,
  hubContactListHubQuery,
  hubContactListIdParam,
  hubCountResetBody,
  hubDisplayNamesField,
  hubDisplayNamesSchema,
  hubIdParam,
  hubIdQuery,
  hubIdentityIdParam,
  hubListNameSchema,
  hubOrgResourceParam,
  hubResourceQuery,
  hubSchemaQuery,
  hubStarterQuestionsField,
  hubStarterQuestionsSchema,
  hubTagChangeRefusalSchema,
  hubTeamIdParam,
  hubTeamUserDeleteParam,
  hubUserIdParam,
  hubWelcomeMessagesField,
  hubWelcomeMessagesSchema,
  idParamSchema,
  importContactBookContactsBody,
  importRowLabels,
  inertResponseCsp,
  intakeReportSourceSchema,
  invitePreviewQuery,
  invitePreviewResponse,
  inviteUnsubscribeBody,
  invoicesQuery,
  isAppearanceMode,
  isAudioAttachmentFileName,
  isAutomationEventType,
  isAutomationGateTrigger,
  isAutomationWebhookAuth,
  isCallUtteranceSpeaker,
  isConsultSystemEvent,
  isCustomerFacingAgentRole,
  isDarkAppearance,
  isDataOpsMeteredOrg,
  isEnabledAgentValue,
  isEventRelativeFollowupType,
  isGateActionKind,
  isMessageKept,
  isMobileAppVersionBelow,
  isMonitorRuleCallableTool,
  isNumericEvaluationVariableType,
  isOperationsQuotaEnforced,
  isPeopleInlineImage,
  isPeopleLiveFrameType,
  isPeopleSurfaceOn,
  isPersistablePeopleThread,
  isRefusedNativeToolName,
  isReviewAccountEmail,
  isRollingWindowPlanType,
  isStrandedPaidRow,
  isStripeBilledPlan,
  isVoiceTaskTitle,
  journeyIdParam,
  kanbanSlugMigrationQuery,
  kanbanStatusesArraySchema,
  kanbanUpdateBody,
  keepInHistoryToInt,
  linkAgentResourceBody,
  linkContactBookContactBody,
  linkOrgResourceBody,
  lintKanbanStatuses,
  listAgentsQuery,
  listAutomationRunsQuery,
  listConnectionsQuery,
  listConsultThreadsQuery,
  listConsultThreadsResponse,
  listContactAccessQuery,
  listContactBookContactsQuery,
  listContactBookListMembersQuery,
  listContactBookSuppressionsQuery,
  listConversationsQuery,
  listExperimentsQuery,
  listHubAggregateSchedulesQuery,
  listHubContactBookContactsQuery,
  listNoticesQuery,
  listOrgCredentialsQuery,
  listOrgResourcesQuery,
  listOrgTagsQuery,
  listOverridesQuery,
  listPendingSchedulesQuery,
  listReportsQuery,
  listResourceFilesQuery,
  listResourceFoldersQuery,
  listResourcesQuery,
  listStatesQuery,
  listTemplatesQuery,
  listToolsQuery,
  listVariantsQuery,
  listWhatsAppTemplatesQuery,
  logoutResponse,
  magicCodeSendBody,
  magicCodeSendResponse,
  magicCodeVerifyBody,
  magicCodeVerifyResponse,
  mergeFlagSource,
  messageAttachment,
  messagesQuery,
  metaEntityId,
  mobileAppVersionSchema,
  mobilePlatformSchema,
  mobileVersionPolicyQuery,
  mobileVersionPolicyResponse,
  mobileVersionPolicySchema,
  monitorActionSchema,
  monitorCallKeysOffTrigger,
  monitorCalleeRefusal,
  monitorCalleeSelections,
  monitorConfigNeedsDelay,
  monitorFiringTriggerClaim,
  monitorInputShapingKeysOnIdle,
  monitorRuleActionKinds,
  monitorRuleKeysOffTrigger,
  monitorRuleReentryTrack,
  monitorRuleToolNotAllowedMessage,
  monitorRuleToolSelections,
  monitorRulesStructuredOutputMessage,
  monitorRulesStructuredOutputRefusal,
  monitorRulesStructuredOutputWriteRefusal,
  monitorSelectedAction,
  monitorTriggerClashMessage,
  monitorUnassignedToolMessage,
  navItemCountResetBody,
  navItemSchema,
  normalizeBillingStatus,
  normalizeContactLabel,
  normalizeContactPhone,
  noticeIdParamSchema,
  noticeScopeSchema,
  noticeSeveritySchema,
  noticeStatusSchema,
  observabilityListParams,
  observabilityParams,
  orgAdminIdParam,
  orgCredentialIdParam,
  orgIdParam,
  orgListReferenceSchema,
  orgResourceFileIdParam,
  orgResourceFolderIdParam,
  orgResourceIdParam,
  orgIdQuery as orgResourcesOrgIdQuery,
  orgTagIdParam,
  ownPeopleName,
  pacingConfigSchema,
  paidTierSchema,
  parseCommunityLessonVideoUrl,
  parseMobileAppVersion,
  passwordLoginBody,
  passwordLoginResponse,
  peopleBlockedUserSchema,
  peopleContactBlockBody,
  peopleContactInviteBody,
  peopleContactInviteIdParam,
  peopleContactPageQuery,
  peopleContactPersonSchema,
  peopleContactSchema,
  peopleContactUserIdParam,
  peopleGroupAvatarUrlSchema,
  peopleGroupCreateBody,
  peopleGroupIncomingInviteIdParam,
  peopleGroupIncomingInviteSchema,
  peopleGroupInviteBody,
  peopleGroupInviteIdParam,
  peopleGroupLeaveBody,
  peopleGroupMemberParam,
  peopleGroupMemberSchema,
  peopleGroupNameSchema,
  peopleGroupRoleSchema,
  peopleGroupSentInviteSchema,
  peopleGroupSummarySchema,
  peopleGroupUpdateBody,
  peopleIncomingInviteSchema,
  peopleInviteEmailSchema,
  peopleMessagePreview,
  peopleModerationActionSchema,
  peopleOrgDirectBody,
  peopleOrgErasureBody,
  peopleOutgoingInviteSchema,
  peopleReportBody,
  peopleReportReasonSchema,
  peopleThreadAttachmentSchema,
  peopleThreadAttachmentUploadSchema,
  peopleThreadAttachmentUrlsBody,
  peopleThreadIdParam,
  peopleThreadKindSchema,
  peopleThreadLastMessageSchema,
  peopleThreadListQuery,
  peopleThreadMemberSchema,
  peopleThreadMessageIdParam,
  peopleThreadMessageSchema,
  peopleThreadMessagesQuery,
  peopleThreadReadBody,
  peopleThreadSendBody,
  peopleThreadSettingsBody,
  peopleThreadSummarySchema,
  peopleUserIdSchema,
  personName,
  pitrBookmarkParam,
  pitrDoNamespace,
  pitrRestoreBody,
  pitrRestoreParam,
  planAllowanceValue,
  planKeySchema,
  portalSessionBody,
  primaryRegionSchema,
  projectedOpsTenthsIncluded,
  putAgentCallOpeningBody,
  readHubDisplayNames,
  readHubPresentation,
  readHubStarterQuestions,
  readHubWelcomeMessages,
  readInsertNoteKeepInHistory,
  readInsertNoteTemplate,
  readRunMonitorCallee,
  readStoredCallOpenings,
  readToolsetBinding,
  reassignHubUserBody,
  recordAiDisclosureAcceptanceBody,
  registerPushTokenBody,
  registerWhatsappBody,
  registerWhatsappQuery,
  rekorAttestation,
  rekorBaseChangeMessageSchema,
  rekorBaseErasurePath,
  rekorBoundAttestation,
  rekorClientSchema,
  rekorEntitlementRefreshMessageSchema,
  rekorResolvedToolsetSchema,
  rekorToolIdSchema,
  rekorToolsetCallPath,
  rekorToolsetFileGetSchema,
  rekorToolsetFileListSchema,
  rekorToolsetFilePutSchema,
  rekorToolsetFileSchema,
  rekorToolsetResolvePath,
  rekorToolsetToolsPath,
  rekorToolsetToolsSchema,
  releaseBody,
  reorderStatesBody,
  replicatePreviewBody,
  reportClassificationSchema,
  reportLocaleSchema,
  reportMessageAuthorRoleSchema,
  reportMessageSchema,
  reportSourceSchema,
  reportStatusSchema,
  reporterListQuery,
  reporterListResponseSchema,
  reporterReportSummarySchema,
  reporterTransitionResponseSchema,
  resendDomainStatusQuery,
  resolveCallUtteranceSpeaker,
  resolveContextBoundary,
  resolveDataAllowanceTotals,
  resolveEffectivePlan,
  resolveHubDisplayName,
  resolveHubPresentation,
  resolveKeepInHistory,
  resolveMonitorHistoryMessages,
  resolveMonitorIncludeToolResults,
  resolveMonitorTrigger,
  resolvedToolsetIsBound,
  resourceFileIdParam,
  resourceFolderIdParam,
  resourceIdParam,
  retryProvisioningQuery,
  runJourneyQuery,
  runSessionQuery,
  scenarioSetIdParam,
  scenarioSetsHubQuery,
  scopeTagIdsOf,
  seedReleaseStatusSchema,
  sendMessageBody,
  sendWhatsAppTemplateBody,
  sentryRefStatusSchema,
  sessionCheckResponse,
  sessionConfigSchema,
  sessionIdParam,
  setExperimentStatusBody,
  setProductionCredentialBody,
  signUrlBody,
  spendCapBody,
  stateIdParam,
  stateOperationBody,
  stateResetParams,
  stateResetResponse,
  storedCallOpening,
  structuredQueryBody,
  submitTemplateBody,
  subscriptionItemParams,
  summarizeToolsetSurface,
  suppressionIdentitySchema,
  syncSkillsBody,
  syncWarningsField,
  templateIdParam,
  templateStatusQuery,
  terminalRunCount,
  testTemplateBody,
  threadLabel,
  threadTitle,
  timestampSchema,
  toggleEvalBody,
  tokenIdParam,
  tokenOrgIdParam,
  toolAgentQuery,
  toolConnectionsQuery,
  toolIdParam,
  toolsetBindingAllowsCustomerFacing,
  toolsetConnectionBindingSchema,
  toolsetConnectionRefusalMessage,
  toolsetFileToolName,
  toolsetFileToolSchema,
  toolsetSurfaceSchema,
  transferBody,
  transitionReportBody,
  turnDeadlineSeconds,
  turnMayCarryAttachments,
  typingBody,
  unlinkAgentResourceQuery,
  unlockHubUserNameResponse,
  unprovenRunCount,
  updateAgentBody,
  updateAgentResourceBody,
  updateAnalyticsViewBody,
  updateAutomationBody,
  updateBillingCurrencyBody,
  updateChannelTestIdentitiesBody,
  updateConsultThreadBody,
  updateConsultThreadResponse,
  updateContactBookContactBody,
  updateContactBookListBody,
  updateContactBookListPinsBody,
  updateCustomToolBody,
  updateEvalBody,
  updateExperimentBody,
  updateFreeOrgLimitBody,
  updateHubBody,
  updateHubContactListBody,
  updateHubTeamBody,
  updateHubUserBody,
  updateHubUserResponse,
  updateJourneyBody,
  updateNoticeBody,
  updateOrgCredentialBody,
  updateOrgResourceBody,
  updateOrgResourceFileBody,
  updateOrgResourceFolderBody,
  updateOrgTagBody,
  updateOrganizationBody,
  updatePlanBody,
  updatePlatformConfigBody,
  updatePreferencesBody,
  updatePricingPlanBody,
  updateProfileBody,
  updateResourceBody,
  updateResourceFileBody,
  updateResourceFolderBody,
  updateScenarioSetBody,
  updateStateBody,
  updateTemplateBody,
  updateToolExecutionConfigBody,
  updateUserBody,
  updateVariablePinBody,
  updateVariantBody,
  uploadOrgResourceFileBody,
  uploadOrgSkillZipBody,
  uploadQuery,
  uploadResourceFileBody,
  uploadSkillZipBody,
  upsertOverrideBody,
  uuidSchema,
  validateEvalBody,
  validateLaneReferences,
  variantIdParam,
  vaultCreateBody,
  vaultIdParam,
  vaultSecretScopeSchema,
  vaultUpdateBody,
  voiceCallMinuteOps,
  whatsappCallbackBody,
  withoutServerOwnedSettings,
  wsTicketResponse
};
//# sourceMappingURL=index.js.map